/* eslint-disable react/jsx-closing-tag-location */
import React from 'react';
import { SvgIcon } from '@mui/material';
import CallIcon from '@mui/icons-material/Call'
import MailIcon from '@mui/icons-material/Mail'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import SmsIcon from '@mui/icons-material/Sms'
import bixpand from '../images/bix.png';
import google from '../images/google.svg';
import yelp from '../images/yelp-icon.svg';
import Facebook from '../images/Facebook.svg';
import Tripadvisor from '../images/tripadvisor-icon.svg';
import OpenTable from '../images/opentable-icon.svg';
import AngiesList from '../images/angieslist-icon.svg';
import TrustPilot from '../images/Trustpilot.svg';
import Realtor from '../images/realtor.png';
import G2 from '../images/G2 CRO.svg';
import config from '../config';
import Clutch from '../images/clutchsvg.png';
import Capterra from '../images/capterra.svg';
import Apartment from '../images/apartment.svg';

const SvgStyle = { verticalAlign: 'bottom' };

export const themeColor = '#005EB2';

export const limitErrorMessage = 'You need to verify the email the business. Please book a meeting with our team';
export const supportMeetingLink = `${config.BixUrl.concat(config.supportMeetingURL)}`;
export const limitErrorCode = 'VERIFY_BUSINESS_EMAIL';
export const graphQl = 'GraphQL error: Error:';
export const graphQlError = 'GraphQL error:';

export const amountValidate = /^\d+(\.\d{1,2})?$/;

export const emailValidation = /^(?!.*[@.]{2,})[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9](?:[a-zA-Z0-9.-]*[a-zA-Z0-9])*\.[a-zA-Z]{2,}$/i;

export const domainValidation = /^\S*$/;

export const bixpandDescription = 'Bixpand - Marketing CRM & Sales, made easy for SMEs';

export const StripeCurrency = [
  { label: 'USD ($)', value: 'USD', symbol: '$' },
  { label: 'INR (₹)', value: 'INR', symbol: '₹' },
  { label: 'CAD ($)', value: 'CAD', symbol: '$' },
  { label: 'AUD ($)', value: 'AUD', symbol: '$' },
  { label: 'GBP (£)', value: 'GBP', symbol: '£' },
];

export const TicketStatusByValue = {
  New: 1,
  InProgress: 2,
  Resolved: 3,
  Closed: 4,
};

export const htmlTemplateStyle = {
  height: '100%',
  width: '235px',
  border: '2px solid black',
  borderRadius: '6px',
  objectFit: 'cover',
  backgroundPosition: 'top',
  backgroundSize: '100%,100%',
  backgroundRepeat: 'no-repeat',
};

export const TicketStatus = {
  1: 'New',
  2: 'In Progress',
  3: 'Resolved',
  4: 'Closed',
};
export const TicketStatusArr = [
  { label: 'New', value: 1 },
  { label: 'In-Progress', value: 2 },
  { label: 'Resolved', value: 3 },
  { label: 'Closed', value: 4 },
];

export const servicesprovider = {
  Google: 1,
  Outlook: 2,
};

export const brand = {
  bixpand: 'bixpand',
  business: 'business',
  fullWhiteLabel: 'fullWhiteLabel',
  noLogo: 'nologo',
  halfWhiteLabel: 'halfWhiteLabel',
};

export const paymentServiceProvider = {
  stripe: 'STRIPE',
  paypal: 'PAYPAL',
};

export const paymentConnectStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const textMarketingLength = 256;
export const ReviewSource = {
  Bixpand: 1,
  Google: 2,
  Yelp: 3,
  Facebook: 4,
  Tripadvisor: 5,
  Opentable: 6,
  Angielist: 7,
  Realtor: 8,
  Trustpilot: 9,
  G2: 10,
  Clutch: 11,
  Capterra: 12,
  Apartments: 13,
};
export const PlanIntervals = {
  ONE_MONTH: 'ONE_MONTH',
  SIX_MONTH: 'SIX_MONTH',
  TWELVE_MONTH: 'TWELVE_MONTH',
};

export const EntityType = {
  Agency: 1,
  Business: 2,
  Location: 3,
  Customer: 4,
  MasterAdmin: 5,
  User: 6,
};
export const fontSize = {
  heading: 20,
  subHeading: 14,
  text: 12,
};
export const AppointmentStatus = {
  draft: 1,
  active: 2,
  inactive: 3,
};

export const AppointmentListType = {
  MyAppointment: 1,
  LocationAppointment: 2,
};
export const ActiveAppointmentStatus = {
  inactive: 'inactive',
};
export const DealType = {
  1: 'New Business',
  2: 'Exiting Business',
};
export const serviceProvider = {
  1: 'Google',
  2: 'Outlook',
};
export const timeFormat = {
  time: 'HH:mm:ss',
  times: 'YYYY-MMM-DD HH:mm A',
};
export const dealType = {
  0: [1, 2],
  'New Business': [1],
  'Exiting Business': [2],
};
export const DealStage = {
  1: 'Appointment scheduled',
  2: 'Qualified to buy',
  3: 'Presentation Schedules',
  4: 'Decision make bought in',
  5: 'Contract sent',
  6: 'Closed Won',
  7: 'Closed Lost',
};

export const ContentMarketingStatus = {
  Published: 1,
  Draft: 2,
};

export const DealStages = {
  Appointmentscheduled: 1,
  Qualifiedtobuy: 2,
  PresentationSchedules: 3,
  Decisionmakeboughtin: 4,
  Contractsent: 5,
  Closedwon: 6,
  Closedlost: 7,
};
export const TaskStages = {
  Notstarted: 1,
  InProgress: 2,
  Completed: 3,
  Overdue: 4,
  Stuck: 5,
};
export const fieldLable = { style: { fontSize: 12 } };
export const AddressType = {
  Contact: 1,
  Organization: 2,
};
export const CampaginStatusInfo = {
  1: 'Publish',
  2: 'Draft',
};
export const fontFamily = '\'Open Sans\', sans-serif';

export const captureLeadStatus = {
  1: 'Active',
  2: 'In-Active',
  3: 'Active Date',
};
export const Roles = {
  MasterAdmin: 1,
  AgencyAdmin: 2,
  AgencyManager: 3,
  BusinessAdmin: 4,
  BusinessManager: 5,
  LocationManager: 6,
  LocationUser: 7,
};

export const NewsLetterStatus = {
  Completed: 1,
  Draft: 2,
  Scheduled: 3,
  Failed: 4,
};
export const NewsLetterStatusList = {
  1: 'Completed',
  2: 'Draft',
  3: 'Scheduled',
  4: 'Failed',
};

export const Agency = {
  active: 1,
  inactive: 2,
};

export const SubscriptionStatus = {
  NA: 1,
  Subscribed: 2,
  UnSubscribe: 3,
};

export const SubscriptionByStatus = [
  { id: 1, value: 'NA' },
  { id: 2, value: 'Subscribed' },
  { id: 3, value: 'UnSubscribe' },
];

export const CRMStatus = {
  1: 'Cold',
  2: 'Hot',
  3: 'Warm',
  4: 'Inactive',
  5: 'Email Incorrect',
  6: 'Unsubscribed',
};
export const contectStatus = {
  1: 'Published',
  2: 'Draft',
};
export const segmentStatus = {
  1: 'active',
  2: 'inactive',
};

export const actionTypeAutomation = {
  email: 1,
  Sms: 2,
  CallTask: 3,
  Task: 4,
};

export const workflowContact = {
  Active: 1,
  Push: 2,
  InActive: 3,
};

export const workflowContactList = {
  1: 'Active',
  2: 'Pause',
  3: 'InActive',
};

export const workflowSteps = {
  Active: 1,
  InActive: 2,
};

export const workflowStatus = {
  Draft: 1,
  Active: 2,
  InActive: 3,
};

export const iconAutomation = {
  1: <MailIcon color="primary" />,
  2: <SmsIcon color="primary" />,
  3: <CallIcon color="primary" />,
  4: <AssignmentTurnedInIcon color="primary" />,
};

export const CRMStatusArray = [1, 2, 3, 4, 5, 6];

export const Days = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  31,
];

export const Hours = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
];

export const Minutes = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45,
  46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
];
export const dateFormatBrowser = 'YYYY-MM-DDTHH:mm:ssZ';

export const domainStatus = {
  1: 'Pending',
  2: 'Verified',
  3: 'Failed',
};
export const dummyimage = 'https://dummyimage.com/250x150/000/fff';
export const customField = [
  'firstname',
  'lastname',
  'primaryemail',
  'phonecountryid',
  'phonenumber',
  'jobid',
  'street1',
  'street2',
  'city',
  'stateid',
  'state',
  'countryid',
  'zip',
  'twitter',
  'linkedin',
  'facebook',
  'tags',
  'source',
  'organizationstreet1',
  'organizationstreet2',
  'organizationcity',
  'organizationstateid',
  'organizationstate',
  'organizationcountryid',
  'organizationzip',
  'categories',
  'attribute1',
  'attribute2',
  'attribute3',
  'attribute4',
  'attribute5',
  'attribute6',
  'attribute7',
  'attribute8',
  'attribute9',
  'attribute10',
  'attribute11',
  'attribute12',
  'attribute13',
  'attribute14',
  'attribute15',
  'attribute16',
  'attribute17',
  'attribute18',
  'attribute19',
  'attribute20',
  'attribute21',
  'attribute22',
  'attribute23',
  'attribute24',
  'attribute25',
  'attribute26',
  'attribute27',
  'attribute28',
  'attribute29',
  'attribute30',
  'attribute31',
  'attribute32',
  'attribute33',
  'attribute34',
  'attribute35',
  'attribute36',
  'attribute37',
  'attribute38',
  'attribute39',
  'attribute40',
  'attribute41',
  'attribute42',
  'attribute43',
  'attribute44',
  'attribute45',
  'attribute46',
  'attribute47',
  'attribute48',
  'attribute49',
  'attribute50',
  'name',
  'orgphonecountryid',
  'orgphonenumber',
  'orgemail',
  'employeesize',
  'yearsinbusiness',
  'revenue',
  'businessstartdate',
  'typeofentity',
  'orgmap',
  'orgwebsite',
  'orgtwitter',
  'orgfacebook',
  'orgstatus',
  'orglinkedin',
  'orggmb',
  'orgyelp',
  'orgtripadvisor',
  'orgtags',
  'orgsource',
  'orgownerid',
  'orgyoutubeurl',
  'orgattribute1',
  'orgattribute2',
  'orgattribute3',
  'orgattribute4',
  'orgattribute5',
  'orgattribute6',
  'orgattribute7',
  'orgattribute8',
  'orgattribute9',
  'orgattribute10',
  'orgattribute11',
  'orgattribute12',
  'orgattribute13',
  'orgattribute14',
  'orgattribute15',
  'orgattribute16',
  'orgattribute17',
  'orgattribute18',
  'orgattribute19',
  'orgattribute20',
  'orgattribute21',
  'orgattribute22',
  'orgattribute23',
  'orgattribute24',
  'orgattribute25',
  'orgattribute26',
  'orgattribute27',
  'orgattribute28',
  'orgattribute29',
  'orgattribute30',
  'orgattribute31',
  'orgattribute32',
  'orgattribute33',
  'orgattribute34',
  'orgattribute35',
  'orgattribute36',
  'orgattribute37',
  'orgattribute38',
  'orgattribute39',
  'orgattribute40',
  'orgattribute41',
  'orgattribute42',
  'orgattribute43',
  'orgattribute44',
  'orgattribute45',
  'orgattribute46',
  'orgattribute47',
  'orgattribute48',
  'orgattribute49',
  'orgattribute50',
];

export const CRMFilter = {
  1: 'Equal To',
  2: 'Not Equal To',
  3: 'In',
  4: 'Not In',
  5: 'Greater Than Or Equal To',
  6: 'Less Than Or Equal To',
  7: 'Date Rang',
};

export const INTEGER = [
  { value: 'Equal To' },
  { value: 'Not Equal To' },
  { value: 'In' },
  { value: 'Not In' },
  { value: 'Greater Than Or Equal To' },
  { value: 'Less Than Or Equal To' },
  { value: 'Is Null' },
  { value: 'Is Not Null' },
];

export const DATE = [
  { value: 'Date Range' },
  { value: 'Is Null' },
  { value: 'Is Not Null' },
];

export const emailStatus = {
  1: 'Not',
  2: 'Pending',
  3: 'Verified',
  4: 'invalid',
};

export const EmailField = [
  '{{FirstName}}',
  '{{LastName}}',
  '{{FullName}}',
  '{{Email}}',
  '{{PhoneNumber}}',
  '{{JobTitle}}',
  '{{City}}',
  '{{State}}',
  '{{Country}}',
  '{{OrganizationName}}',
  '{{OrganizationEmail}}',
  '{{OrganizationPhoneNumber}}',
  '{{OrganizationCategories}}',
  '{{OrganizationWebsite}}',
  '{{OrganizationCity}}',
  '{{OrganizationState}}',
  '{{OrganizationCountry}}',
];

export const FieldType = [
  { id: 1, value: 'Single-line text' },
  { id: 2, value: 'Multi-line text' },
  { id: 3, value: 'Single checkbox' },
  { id: 4, value: 'Multiple checkbox' },
  { id: 5, value: 'Dropdown select' },
  { id: 6, value: 'Radio select' },
  { id: 7, value: 'Date picker' },
  { id: 8, value: 'Number' },
  { id: 9, value: 'Phonenumber' },
  { id: 10, value: 'Rating' },
  { id: 11, value: 'Paragraph' },
];
export const FieldTypeDropdown = [
  { id: 5, value: 'Dropdown select' },
];

export const FieldTypeNumber = {
  1: 'Single-line text',
  2: 'Multi-line text',
  3: 'Single checkbox',
  4: 'Multiple checkbox',
  5: 'Dropdown select',
  6: 'Radio select',
  7: 'Date picker',
  8: 'Number',
  9: 'Phonenumber',
  10: 'Rating',
  11: 'Paragraph',
};

export const getFieldType = {
  Singlelinetext: 1,
  Multilinetext: 2,
  Singlecheckbox: 3,
  Multiplecheckbox: 4,
  Dropdownselect: 5,
  Radioselect: 6,
  Datepicker: 7,
  Numbers: 8,
  Phonenumber: 9,
  Rating: 10,
  Paragraph: 11,
};

export const PropertiesObjType = [
  { key: 'Contact', value: 'contact' },
  { key: 'Organization', value: 'organization' },
];

export const PropertiesObj = [
  { key: 'Contact', value: 'contact' },
  { key: 'Organization', value: 'organization' },
  { key: 'Deals', value: 'deals' },
];

export const emailMarketingColumnStatus = {
  Google: 1,
  Outlook: 2,
};

export const STRING = [
  { value: 'Equal To' },
  { value: 'Not Equal To' },
  { value: 'In' },
  { value: 'Not In' },
  { value: 'Like' },
  { value: 'Is Null' },
  { value: 'Is Not Null' },
];

export const UUID = [
  { value: 'Equal To' },
  { value: 'Not Equal To' },
  { value: 'In' },
  { value: 'Not In' },
  { value: 'Is Null' },
  { value: 'Is Not Null' },
];

export const Json = [
  { value: 'Equal To' },
  { value: 'In' },
  { value: 'Like' },
  { value: 'Is Null' },
  { value: 'Is Not Null' },
];

export const BOOLEAN = [
  { value: 'Equal To' },
  { value: 'Is Null' },
  { value: 'Is Not Null' },
];

export const TochlessPubilcStatus = {
  Warm: 3,
};

export const PersonalizationTag = 'Personalization Tag';

export const columnSelected = [
  { columnname: 'Phone', dbcolumnname: 'phonenumber', table: 'contact' },
  { columnname: 'Lifecycle', dbcolumnname: 'lifecyclestage', table: 'contact' },
  { columnname: 'Status', dbcolumnname: 'status', table: 'contact' },
  { columnname: 'Tags', dbcolumnname: 'tags', table: 'contact' },
  { columnname: 'Source', dbcolumnname: 'source', table: 'contact' },
  { columnname: 'Contact Owner', dbcolumnname: 'owneruser', table: 'contact' },
  { columnname: 'Created', dbcolumnname: 'createdAt', table: 'contact' },
  { columnname: 'Action', dbcolumnname: 'istargetlist', table: 'contact' },
];
export const CRMTasktype = {
  1: 'To do',
  2: 'Call',
  3: 'Email',
};

export const formTypes = [
  // {
  //   id: 0,
  //   name: 'Bar',
  //   icon: <SvgIcon
  //     color="primary"
  //     style={SvgStyle}
  //     viewBox="0 0 30 30"
  //   >
  //     <rect width="30" height="30" rx="3" fill="#005EB2" />
  //     <rect x="2" y="2" width="26" height="26" rx="3" fill="white" />
  //     <rect x="3" y="4" width="23" height="2" rx="1" fill="#005EB2" />
  //     <rect x="3" y="8" width="19" height="2" rx="1" fill="#005EB2" />
  //     <rect x="3" y="12" width="12" height="2" rx="1" fill="#005EB2" />
  //     <rect x="6" y="23" width="17" height="3" rx="0.5" fill="#005EB2" />
  //   </SvgIcon>,
  //   description: 'Add a form that will drop down from the top of the screen.',
  //   disabled: false,
  //   image: false,
  //   onLoad: false,
  //   pageScroll: false,
  //   exitIntent: false,
  //   elapsedTime: false,
  //   fixedDisplay: false,
  //   position: ['Top', 'Bottom'],
  //   fields: [
  //     { name: 'firstName', label: 'First Name', disable: true },
  //     { name: 'email', label: 'Email', disable: true },
  //   ],
  // },
  // {
  //   id: 1,
  //   name: 'Click Triggered Popup',
  //   icon: <SvgIcon
  //     color="primary"
  //     style={SvgStyle}
  //     viewBox="0 0 30 31"
  //   >
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M3 0C1.34315 0 0 1.34315 0
  //  3V22.1058C0 23.7627 1.34315
  //  25.1058 3 25.1058H11.4768C11.4842 25.2694 11.5328 25.4357 11.6303 25.5911L14.1528
  //   29.6131C14.5447 30.238 15.4552 30.238 15.8472 29.6131L18.3697 25.5911C18.4672 25.4357
  //   18.5158 25.2694 18.5232 25.1058H27C28.6569 25.1058 30 23.7627 30 22.1058V3C30 1.34315
  // 28.6569 0
  //    27 0H3Z"
  //       fill="#005EB2"
  //     />
  //     <rect x="2" y="6" width="26" height="17" rx="2" fill="white" />
  //     <circle cx="4" cy="3.00003" r="1" fill="white" />
  //     <circle cx="7" cy="3.00003" r="1" fill="white" />
  //     <circle cx="10" cy="3.00003" r="1" fill="white" />
  //     <rect
  //       x="5.25"
  //       y="8.25"
  //       width="19.5"
  //       height="12.5"
  //       rx="0.75"
  //       fill="white"
  //       stroke="#005EB2"
  //       strokeWidth="0.5"
  //     />
  //     <rect x="7" y="10" width="12" height="1" rx="0.5" fill="#005EB2" />
  //     <rect x="7" y="12" width="7" height="1" rx="0.5" fill="#005EB2" />
  //     <rect x="7" y="14" width="5" height="1" rx="0.5" fill="#005EB2" />
  //     <rect x="19" y="18" width="4" height="1" rx="0.5" fill="#005EB2" />
  //   </SvgIcon>,
  //   description: 'Add a form that pops up as a box in the center of the page.',
  //   disabled: false,
  //   image: false,
  //   onLoad: false,
  //   pageScroll: false,
  //   exitIntent: false,
  //   elapsedTime: false,
  //   fixedDisplay: true,
  //   position: ['Center', 'Right-Bottom', 'Left-Bottom'],
  //   fields: [
  //     { name: 'firstName', label: 'First Name', disable: true },
  //     { name: 'lastName', label: 'Last Name' },
  //     { name: 'email', label: 'Email', disable: true },
  //     { name: 'phoneNumber', label: 'Phone Number' },
  //   ],
  // },
  {
    id: 2,
    name: 'Embedded Form',
    icon: <svg width="24" height="24" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="30" height="30" rx="3" fill="#005EB2" />
      <rect x="9" y="1" width="1" height="28" rx="0.5" fill="white" />
      <rect x="14" y="1" width="1" height="28" rx="0.5" fill="white" />
      <rect x="19" y="1" width="1" height="28" rx="0.5" fill="white" />
      <rect x="29" y="9" width="1" height="28" rx="0.5" transform="rotate(90 29 9)" fill="white" />
      <rect x="29" y="14" width="1" height="28" rx="0.5" transform="rotate(90 29 14)" fill="white" />
      <rect x="29" y="19" width="1" height="28" rx="0.5" transform="rotate(90 29 19)" fill="white" />
      <rect x="4" y="4" width="22" height="22" rx="3" fill="white" />
      <rect x="7" y="14" width="15" height="2" rx="1" fill="#005EB2" />
      <rect x="8" y="18" width="9" height="2" rx="1" fill="#005EB2" />
      <rect x="11" y="10" width="9" height="2" rx="1" fill="#005EB2" />
      <path d="M6.87459 13C6.48515 12.9321 6.19142 12.82 5.9934 12.6638C5.79758 12.5089 5.69967 12.3038 5.69967 12.0484V11.6429C5.69967 11.3128 5.46645 11.1477 5 11.1477V10.8523C5.46645 10.8523 5.69967 10.6879 5.69967 10.3591V9.9353C5.70407 9.6867 5.80198 9.48633 5.9934 9.33418C6.18702 9.18068 6.48075 9.06928 6.87459 9L7 9.23434C6.54015 9.32535 6.31023 9.5624 6.31023 9.94549V10.3571C6.31023 10.6655 6.12651 10.8801 5.75908 11.001C6.12651 11.1233 6.31023 11.34 6.31023 11.651V12.0708C6.31683 12.4444 6.54675 12.676 7 12.7657L6.87459 13Z" fill="#005EB2" />
      <path d="M22.1254 17C22.5149 17.0679 22.8086 17.18 23.0066 17.3362C23.2024 17.4911 23.3003 17.6962 23.3003 17.9516V18.3571C23.3003 18.6872 23.5336 18.8523 24 18.8523V19.1477C23.5336 19.1477 23.3003 19.3121 23.3003 19.6409V20.0647C23.2959 20.3133 23.198 20.5137 23.0066 20.6658C22.813 20.8193 22.5193 20.9307 22.1254 21L22 20.7657C22.4598 20.6746 22.6898 20.4376 22.6898 20.0545V19.6429C22.6898 19.3345 22.8735 19.1199 23.2409 18.999C22.8735 18.8767 22.6898 18.66 22.6898 18.349V17.9292C22.6832 17.5556 22.4532 17.324 22 17.2343L22.1254 17Z" fill="#005EB2" />
    </svg>,
    description: 'Create a form that you can embed as part of your website.',
    disabled: false,
    image: false,
    onLoad: false,
    pageScroll: false,
    exitIntent: false,
    elapsedTime: false,
    fixedDisplay: false,
    fields: [
      { name: 'firstName', label: 'First Name', disable: true },
      { name: 'lastName', label: 'Last Name' },
      { name: 'email', label: 'Email', disable: true },
      { name: 'phoneNumber', label: 'Phone Number' },
    ],
  },
  {
    id: 3,
    name: 'Pop-Up Box',
    icon:
      <svg width="24" height="24" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="30" height="30" rx="3" fill="#005EB2" />
        <rect x="2" y="2" width="26" height="26" rx="3" fill="white" />
        <rect x="9.5" y="5.5" width="15" height="15" rx="1.5" stroke="#005EB2" />
        <rect x="5.5" y="10.5" width="15" height="15" rx="1.5" fill="#005EB2" stroke="white" />
        <path d="M12 19L8 23" stroke="white" strokeWidth="0.666667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.66666 19H12V22.3333" stroke="white" strokeWidth="0.666667" strokeLinecap="round" strokeLinejoin="round" />
      </svg>,
    description: 'Add a form that pops up as a box in the center of the page.',
    disabled: false,
    image: false,
    onLoad: true,
    pageScroll: true,
    exitIntent: true,
    elapsedTime: true,
    fixedDisplay: false,
    position: ['Center', 'Right-Bottom', 'Left-Bottom'],
    fields: [
      { name: 'firstName', label: 'First Name', disable: true },
      { name: 'lastName', label: 'Last Name' },
      { name: 'email', label: 'Email', disable: true },
      { name: 'phoneNumber', label: 'Phone Number' },
    ],
  },
  // {
  //   id: 4,
  //   name: 'Sidebar',
  //   icon: <SvgIcon
  //     color="primary"
  //     style={SvgStyle}
  //     viewBox="0 0 30 30"
  //   >
  //     <rect width="30" height="30" rx="3" fill="#005EB2" />
  //     <circle cx="3" cy="3" r="1" fill="white" />
  //     <circle cx="6" cy="3" r="1" fill="white" />
  //     <circle cx="9" cy="3" r="1" fill="white" />
  //     <rect x="2" y="6" width="8" height="22" rx="1" fill="white" />
  //     <rect x="12" y="6" width="16" height="22" rx="1" fill="white" />
  //     <rect x="4" y="10.6667" width="2.66667" height="0.666667" rx="0.333333" fill="#005EB2" />
  //     <rect x="4" y="9.33334" width="2.66667" height="0.666667" rx="0.333333" fill="#005EB2" />
  //     <rect x="4" y="8" width="2.66667" height="0.666667" rx="0.333333" fill="#005EB2" />
  //     <circle cx="7.66666" cy="8.33336" r="0.333333" fill="#005EB2" />
  //     <circle cx="7.66666" cy="9.66668" r="0.333333" fill="#005EB2" />
  //     <circle cx="7.66666" cy="11" r="0.333333" fill="#005EB2" />
  //     <rect x="13" y="8" width="13" height="1" rx="0.5" fill="#005EB2" />
  //     <rect x="13" y="11" width="8" height="1" rx="0.5" fill="#005EB2" />
  //     <rect x="13" y="14" width="6" height="1" rx="0.5" fill="#005EB2" />
  //   </SvgIcon>,
  //   description: 'Add a form that slides.',
  //   disabled: false,
  //   image: false,
  //   onLoad: false,
  //   pageScroll: false,
  //   exitIntent: false,
  //   elapsedTime: false,
  //   fixedDisplay: false,
  //   position: ['Left-Bottom', 'Left-Center', 'Right-Bottom', 'Right-Center'],
  //   fields: [
  //     { name: 'firstName', label: 'First Name', disable: true },
  //     { name: 'lastName', label: 'Last Name' },
  //     { name: 'email', label: 'Email', disable: true },
  //     { name: 'phoneNumber', label: 'Phone Number' },
  //   ],
  // },
  {
    id: 5,
    name: 'Subscription Form',
    icon: <svg width="24" height="24" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.1325 2.07178V3.52632H7.86687L7.23406 2.61084H7.22341V3.52632H6.91588V2.07178H7.18577L7.81361 2.98655H7.82639V2.07178H8.1325ZM8.98658 3.52632V2.07178H9.9667V2.32533H9.29411V2.67192H9.91627V2.92547H9.29411V3.27277H9.96954V3.52632H8.98658ZM11.1386 3.52632L10.7224 2.07178H11.0584L11.2991 3.08243H11.3112L11.5768 2.07178H11.8645L12.1294 3.08456H12.1422L12.3829 2.07178H12.7189L12.3027 3.52632H12.003L11.726 2.57533H11.7146L11.4383 3.52632H11.1386ZM14.2588 2.4901C14.2532 2.43281 14.2288 2.3883 14.1857 2.35658C14.1426 2.32485 14.0841 2.30899 14.0103 2.30899C13.9601 2.30899 13.9177 2.31609 13.8831 2.3303C13.8486 2.34403 13.8221 2.36321 13.8036 2.38783C13.7856 2.41245 13.7766 2.44038 13.7766 2.47163C13.7757 2.49768 13.7811 2.5204 13.7929 2.53982C13.8053 2.55923 13.8221 2.57604 13.8434 2.59024C13.8647 2.60397 13.8893 2.61605 13.9172 2.62646C13.9452 2.63641 13.975 2.64493 14.0067 2.65203L14.1374 2.68328C14.2008 2.69749 14.2591 2.71643 14.3121 2.7401C14.3651 2.76377 14.4111 2.79289 14.4499 2.82746C14.4887 2.86202 14.5188 2.90274 14.5401 2.94962C14.5619 2.99649 14.573 3.05023 14.5735 3.11084C14.573 3.19985 14.5503 3.27703 14.5053 3.34237C14.4608 3.40724 14.3964 3.45767 14.3121 3.49365C14.2283 3.52916 14.1272 3.54692 14.0088 3.54692C13.8914 3.54692 13.7892 3.52893 13.702 3.49294C13.6154 3.45696 13.5477 3.40369 13.4989 3.33314C13.4506 3.26212 13.4253 3.17429 13.4229 3.06965H13.7205C13.7238 3.11841 13.7378 3.15913 13.7624 3.1918C13.7875 3.224 13.8209 3.24839 13.8625 3.26496C13.9047 3.28106 13.9523 3.28911 14.0053 3.28911C14.0574 3.28911 14.1026 3.28153 14.141 3.26638C14.1798 3.25123 14.2098 3.23016 14.2311 3.20317C14.2525 3.17618 14.2631 3.14517 14.2631 3.11013C14.2631 3.07746 14.2534 3.05 14.234 3.02774C14.2151 3.00549 14.1871 2.98655 14.1502 2.97092C14.1137 2.9553 14.069 2.94109 14.016 2.92831L13.8576 2.88854C13.7349 2.85871 13.6381 2.81207 13.5671 2.74862C13.4961 2.68518 13.4608 2.59971 13.4613 2.49223C13.4608 2.40416 13.4842 2.32722 13.5316 2.26141C13.5794 2.19559 13.645 2.14422 13.7283 2.10729C13.8116 2.07036 13.9063 2.05189 14.0124 2.05189C14.1204 2.05189 14.2146 2.07036 14.2951 2.10729C14.376 2.14422 14.439 2.19559 14.484 2.26141C14.529 2.32722 14.5522 2.40345 14.5536 2.4901H14.2588Z" fill="#005EB2" />
      <path d="M4.68421 6.78947L1 10.4737M4.68421 6.78947V1H17.3158V6.78947M4.68421 6.78947V12.4127M1 10.4737V21M1 10.4737L4.68421 12.4127M21 10.4737L17.3158 6.78947M21 10.4737V21M21 10.4737L17.3158 12.4127M17.3158 6.78947L17.3158 12.4127M1 21H21M1 21L9.18077 14.7794M21 21L12.8192 14.7794M9.18077 14.7794L11 15.7368L12.8192 14.7794M9.18077 14.7794L4.68421 12.4127M12.8192 14.7794L17.3158 12.4127" stroke="#005EB2" strokeWidth="0.5" />
      <path d="M14.1579 10.4737H15.7368" stroke="#005EB2" strokeWidth="0.5" />
      <path d="M6.26315 12.0526H8.89473" stroke="#005EB2" strokeWidth="0.5" />
      <path d="M6.26315 10.4737H13.1053" stroke="#005EB2" strokeWidth="0.5" />
      <path d="M8.89474 8.63158H15.7369" stroke="#005EB2" strokeWidth="0.5" />
      <path d="M6.26315 8.63158H8.14768" stroke="#005EB2" strokeWidth="0.5" />
      <path d="M8.89473 6.78947H13.1053M6.26315 6.78947H7.8421M14.1579 6.78947H15.7368" stroke="#005EB2" strokeWidth="0.5" />
      <path d="M8.89473 5.21053H15.2105M6.26315 5.21053H7.8421" stroke="#005EB2" strokeWidth="0.5" />
      <path d="M9.94736 12.0526H15.7368" stroke="#005EB2" strokeWidth="0.5" />
      <path d="M2.05264 18.8947L2.05264 14.1579" stroke="#005EB2" strokeWidth="0.5" />
      <path d="M19.9474 18.8947L19.9474 14.1579" stroke="#005EB2" strokeWidth="0.5" />
      <path d="M19.9474 13.6316V12.5789" stroke="#005EB2" strokeWidth="0.5" />
      <path d="M2.05264 12.5789V13.6316" stroke="#005EB2" strokeWidth="0.5" />
    </svg>,
    description: 'Create a form that you can embed as part of your website.',
    disabled: false,
    image: false,
    onLoad: false,
    pageScroll: false,
    exitIntent: false,
    elapsedTime: false,
    fixedDisplay: false,
    fields: [
      { name: 'firstName', label: 'First Name', disable: true },
      { name: 'lastName', label: 'Last Name' },
      { name: 'email', label: 'Email', disable: true },
      { name: 'phoneNumber', label: 'Phone Number' },
    ],
  },
];
export const radioButtonsForm = [
  {
    id: 1,
    name: 'Form Step',
    disabled: false,
  },
  {
    id: 2,
    name: 'Non-Bixpand URL',
    disabled: false,
  },
  {
    id: 3,
    name: 'File Download',
    disabled: false,
  },
  {
    id: 4,
    name: 'Meeting Link',
    disabled: true,
  },
  {
    id: 5,
    name: 'Calendar Event',
    disabled: true,
  },
];
export const radioButtonsFormThankYou = [
  {
    id: 2,
    name: 'Non-Bixpand URL',
    disabled: false,
  },
  {
    id: 3,
    name: 'File Download',
    disabled: false,
  },
  {
    id: 4,
    name: 'Meeting Link',
    disabled: true,
  },
  {
    id: 5,
    name: 'Calendar Event',
    disabled: true,
  },
];
export const CRMTaskPriority = {
  1: 'High',
  2: 'Medium',
  3: 'Low',
};

export const CRMEmailServicesProvider = {
  1: 'Bixpand Email Service',
  2: 'Gmail Service',
  3: 'Outlook Email Service',
};
export const TouchLessPublicId = {
  ReviewUs: 0,
  Rating: 1,
};
export const EmailServicesProvider = {
  BixpandEmailService: 1,
  GmailService: 2,
  OutlookEmailService: 3,
};

export const CRMCommentType = {
  note: 1,
  task: 2,
  docs: 3,
  deal: 4,
};

export const CRMTaskStatus = {
  1: 'Not Started',
  2: 'In Progress',
  3: 'Completed',
  4: 'Overdue',
  5: 'Stuck',
};

export const CampaginStatus = {
  Draft: 1,
  Completed: 2,
  Scheduled: 3,
  Failed: 4,
};
export const TemplateType = {
  Premium: 1,
  Free: 2,
};

export const RatingColor = {
  IconFilled: '#0259a8',
  IconHover: '#0259a8',
  IconEmpty: '#74b6f7',
};
export const CRMEmailStatus = {
  Draft: 1,
  Completed: 2,
  Scheduled: 3,
  Failed: 4,
  replied: 5,
};
export const ReviewStatus = {
  1: 'Feedback',
  2: 'Review',
  3: 'Rating',
  4: 'Negative Rating',
};
export const ReviewByStatus = {
  Feedback: 1,
  Review: 2,
  Rating: 3,
  NegativeRating: 4,
};
export const ReviewImage = {
  1: bixpand,
  2: google,
  3: yelp,
  4: Facebook,
  5: Tripadvisor,
  6: OpenTable,
  7: AngiesList,
  8: Realtor,
  9: TrustPilot,
  10: G2,
  11: Clutch,
  12: Capterra,
  13: Apartment,
};
export const ActivityObjectTypes = {
  contact: 1,
  note: 2,
  organizations: 3,
  email: 4,
  document: 5,
  task: 6,
  sms: 7,
};
export const ReviewStatusApi = {
  NegativeComment: 1,
  PositiveComment: 2,
  RatingPositiveComment: 3,
  RatingNegativeComment: 4,
};
export const CRMLifecyclestage = {
  1: 'Subscriber',
  2: 'Lead',
  3: 'Marketing Qualified Lead',
  4: 'Sales Qualified Lead',
  5: 'Opportunity',
  6: 'Customer',
  7: 'Competitor',
  8: 'Partner',
  9: 'Vendor',
  10: 'Annonymous',
  11: 'Other',
  12: 'Unsubscribed',
  13: 'Data Incorrect',
};
export const contactFormTypes = { popup: 'Pop-Up Box', embeddedPage: 'Embedded From', standalonePage: 'Standalone Page' };
export const CRMLifecyclestageArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
export const CRMLifecyclestageByStatus = {
  Lead: 2,
  Customer: 6,
};

export const TimeZoneList = [
  'Africa/Abidjan',
  'Africa/Accra',
  'Africa/Addis_Ababa',
  'Africa/Algiers',
  'Africa/Asmara',
  'Africa/Asmera',
  'Africa/Bamako',
  'Africa/Bangui',
  'Africa/Banjul',
  'Africa/Bissau',
  'Africa/Blantyre',
  'Africa/Brazzaville',
  'Africa/Bujumbura',
  'Africa/Cairo',
  'Africa/Casablanca',
  'Africa/Ceuta',
  'Africa/Conakry',
  'Africa/Dakar',
  'Africa/Dar_es_Salaam',
  'Africa/Djibouti',
  'Africa/Douala',
  'Africa/El_Aaiun',
  'Africa/Freetown',
  'Africa/Gaborone',
  'Africa/Harare',
  'Africa/Johannesburg',
  'Africa/Juba',
  'Africa/Kampala',
  'Africa/Khartoum',
  'Africa/Kigali',
  'Africa/Kinshasa',
  'Africa/Lagos',
  'Africa/Libreville',
  'Africa/Lome',
  'Africa/Luanda',
  'Africa/Lubumbashi',
  'Africa/Lusaka',
  'Africa/Malabo',
  'Africa/Maputo',
  'Africa/Maseru',
  'Africa/Mbabane',
  'Africa/Mogadishu',
  'Africa/Monrovia',
  'Africa/Nairobi',
  'Africa/Ndjamena',
  'Africa/Niamey',
  'Africa/Nouakchott',
  'Africa/Ouagadougou',
  'Africa/Porto-Novo',
  'Africa/Sao_Tome',
  'Africa/Timbuktu',
  'Africa/Tripoli',
  'Africa/Tunis',
  'Africa/Windhoek',
  'America/Adak',
  'America/Anchorage',
  'America/Anguilla',
  'America/Antigua',
  'America/Araguaina',
  'America/Argentina/Buenos_Aires',
  'America/Argentina/Catamarca',
  'America/Argentina/ComodRivadavia',
  'America/Argentina/Cordoba',
  'America/Argentina/Jujuy',
  'America/Argentina/La_Rioja',
  'America/Argentina/Mendoza',
  'America/Argentina/Rio_Gallegos',
  'America/Argentina/Salta',
  'America/Argentina/San_Juan',
  'America/Argentina/San_Luis',
  'America/Argentina/Tucuman',
  'America/Argentina/Ushuaia',
  'America/Aruba',
  'America/Asuncion',
  'America/Atikokan',
  'America/Atka',
  'America/Bahia',
  'America/Bahia_Banderas',
  'America/Barbados',
  'America/Belem',
  'America/Belize',
  'America/Blanc-Sablon',
  'America/Boa_Vista',
  'America/Bogota',
  'America/Boise',
  'America/Buenos_Aires',
  'America/Cambridge_Bay',
  'America/Campo_Grande',
  'America/Cancun',
  'America/Caracas',
  'America/Catamarca',
  'America/Cayenne',
  'America/Cayman',
  'America/Chicago',
  'America/Chihuahua',
  'America/Coral_Harbour',
  'America/Cordoba',
  'America/Costa_Rica',
  'America/Creston',
  'America/Cuiaba',
  'America/Curacao',
  'America/Danmarkshavn',
  'America/Dawson',
  'America/Dawson_Creek',
  'America/Denver',
  'America/Detroit',
  'America/Dominica',
  'America/Edmonton',
  'America/Eirunepe',
  'America/El_Salvador',
  'America/Ensenada',
  'America/Fort_Nelson',
  'America/Fort_Wayne',
  'America/Fortaleza',
  'America/Glace_Bay',
  'America/Godthab',
  'America/Goose_Bay',
  'America/Grand_Turk',
  'America/Grenada',
  'America/Guadeloupe',
  'America/Guatemala',
  'America/Guayaquil',
  'America/Guyana',
  'America/Halifax',
  'America/Havana',
  'America/Hermosillo',
  'America/Indiana/Indianapolis',
  'America/Indiana/Knox',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Tell_City',
  'America/Indiana/Vevay',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Indianapolis',
  'America/Inuvik',
  'America/Iqaluit',
  'America/Jamaica',
  'America/Jujuy',
  'America/Juneau',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  ' America/Knox_IN',
  ' America/Kralendijk',
  ' America/La_Paz',
  ' America/Lima',
  ' America/Los_Angeles',
  ' America/Louisville',
  ' America/Lower_Princes',
  ' America/Maceio',
  ' America/Managua',
  ' America/Manaus',
  ' America/Marigot',
  ' America/Martinique',
  ' America/Matamoros',
  ' America/Mazatlan',
  ' America/Mendoza',
  ' America/Menominee',
  ' America/Merida',
  ' America/Metlakatla',
  ' America/Mexico_City',
  ' America/Miquelon',
  ' America/Moncton',
  ' America/Monterrey',
  ' America/Montevideo',
  'America/Montreal',
  'America/Montserrat',
  'America/Nassau',
  'America/New_York',
  'America/Nipigon',
  'America/Nome',
  'America/Noronha',
  'America/North_Dakota/Beulah',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/Ojinaga',
  'America/Panama',
  'America/Pangnirtung',
  'America/Paramaribo',
  'America/Phoenix',
  'America/Port-au-Prince',
  'America/Port_of_Spain',
  'America/Porto_Acre',
  'America/Porto_Velho',
  'America/Puerto_Rico',
  'America/Punta_Arenas',
  'America/Rainy_River',
  'America/Rankin_Inlet',
  'America/Recife',
  'America/Regina',
  'America/Resolute',
  'America/Rio_Branco',
  'America/Rosario',
  'America/Santa_Isabel',
  'America/Santarem',
  'America/Santiago',
  'America/Santo_Domingo',
  'America/Sao_Paulo',
  'America/Scoresbysund',
  'America/Shiprock',
  'America/Sitka',
  'America/St_Barthelemy',
  'America/St_Johns',
  'America/St_Kitts',
  'America/St_Lucia',
  'America/St_Thomas',
  'America/St_Vincent',
  'America/Swift_Current',
  'America/Tegucigalpa',
  'America/Thule',
  'America/Thunder_Bay',
  'America/Tijuana',
  'America/Toronto',
  'America/Tortola',
  'America/Vancouver',
  'America/Virgin',
  'America/Whitehorse',
  'America/Winnipeg',
  'America/Yakutat',
  'America/Yellowknife',
  'Antarctica/Casey',
  'Antarctica/Davis',
  'Antarctica/DumontDUrville',
  'Antarctica/Macquarie',
  'Antarctica/Mawson',
  'Antarctica/McMurdo',
  'Antarctica/Palmer',
  'Antarctica/Rothera',
  'Antarctica/South_Pole',
  'Antarctica/Syowa',
  'Antarctica/Troll',
  'Antarctica/Vostok',
  'Arctic/Longyearbyen',
  'Asia/Aden',
  'Asia/Almaty',
  'Asia/Amman',
  'Asia/Anadyr',
  'Asia/Aqtau',
  'Asia/Aqtobe',
  'Asia/Ashgabat',
  'Asia/Ashkhabad',
  'Asia/Atyrau',
  'Asia/Baghdad',
  'Asia/Bahrain',
  'Asia/Baku',
  'Asia/Bangkok',
  'Asia/Barnaul',
  'Asia/Beirut',
  'Asia/Bishkek',
  'Asia/Brunei',
  'Asia/Calcutta',
  'Asia/Chita',
  'Asia/Choibalsan',
  'Asia/Chongqing',
  'Asia/Chungking',
  'Asia/Colombo',
  'Asia/Dacca',
  'Asia/Damascus',
  'Asia/Dhaka',
  'Asia/Dili',
  'Asia/Dubai',
  'Asia/Dushanbe',
  'Asia/Famagusta',
  'Asia/Gaza',
  'Asia/Harbin',
  'Asia/Hebron',
  'Asia/Ho_Chi_Minh',
  'Asia/Hong_Kong',
  'Asia/Hovd',
  'Asia/Irkutsk',
  'Asia/Istanbul',
  'Asia/Jakarta',
  'Asia/Jayapura',
  'Asia/Jerusalem',
  'Asia/Kabul',
  'Asia/Kamchatka',
  'Asia/Karachi',
  'Asia/Kashgar',
  'Asia/Kathmandu',
  'Asia/Katmandu',
  'Asia/Khandyga',
  'Asia/Kolkata',
  'Asia/Krasnoyarsk',
  'Asia/Kuala_Lumpur',
  'Asia/Kuching',
  'Asia/Kuwait',
  'Asia/Macao',
  'Asia/Macau',
  'Asia/Magadan',
  'Asia/Makassar',
  'Asia/Manila',
  'Asia/Muscat',
  'Asia/Nicosia',
  'Asia/Novokuznetsk',
  'Asia/Novosibirsk',
  'Asia/Omsk',
  'Asia/Oral',
  'Asia/Phnom_Penh',
  'Asia/Pontianak',
  'Asia/Pyongyang',
  'Asia/Qatar',
  'Asia/Qyzylorda',
  'Asia/Rangoon',
  'Asia/Riyadh',
  'Asia/Saigon',
  'Asia/Sakhalin',
  'Asia/Samarkand',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Srednekolymsk',
  'Asia/Taipei',
  'Asia/Tashkent',
  'Asia/Tbilisi',
  'Asia/Tehran',
  'Asia/Tel_Aviv',
  'Asia/Thimbu',
  'Asia/Thimphu',
  'Asia/Tokyo',
  'Asia/Tomsk',
  'Asia/Ujung_Pandang',
  'Asia/Ulaanbaatar',
  'Asia/Ulan_Bator',
  'Asia/Urumqi',
  'Asia/Ust-Nera',
  'Asia/Vientiane',
  'Asia/Vladivostok',
  'Asia/Yakutsk',
  'Asia/Yangon',
  'Asia/Yekaterinburg',
  'Asia/Yerevan',
  'Atlantic/Azores',
  'Atlantic/Bermuda',
  'Atlantic/Canary',
  'Atlantic/Cape_Verde',
  'Atlantic/Faeroe',
  'Atlantic/Faroe',
  'Atlantic/Jan_Mayen',
  'Atlantic/Madeira',
  'Atlantic/Reykjavik',
  'Atlantic/South_Georgia',
  'Atlantic/St_Helena',
  'Atlantic/Stanley',
  'Australia/ACT',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Broken_Hill',
  'Australia/Canberra',
  'Australia/Currie',
  'Australia/Darwin',
  'Australia/Eucla',
  'Australia/Hobart',
  'Australia/LHI',
  'Australia/Lindeman',
  'Australia/Lord_Howe',
  'Australia/Melbourne',
  'Australia/NSW',
  'Australia/North',
  'Australia/Perth',
  'Australia/Queensland',
  'Australia/South',
  'Australia/Sydney',
  'Australia/Tasmania',
  'Australia/Victoria',
  'Australia/West',
  'Australia/Yancowinna',
  'Brazil/Acre',
  'Brazil/DeNoronha',
  'Brazil/East',
  'Brazil/West',
  'CET',
  'CST6CDT',
  'Canada/Atlantic',
  'Canada/Central',
  'Canada/Eastern',
  'Canada/Mountain',
  'Canada/Newfoundland',
  'Canada/Pacific',
  'Canada/Saskatchewan',
  'Canada/Yukon',
  'Chile/Continental',
  'Chile/EasterIsland',
  'Cuba',
  'EET',
  'EST',
  'EST5EDT',
  'Egypt',
  'Eire',
  'Etc/GMT',
  'Etc/GMT+0',
  'Etc/GMT+1',
  'Etc/GMT+10',
  'Etc/GMT+11',
  'Etc/GMT+12',
  'Etc/GMT+2',
  'Etc/GMT+3',
  'Etc/GMT+4',
  'Etc/GMT+5',
  'Etc/GMT+6',
  'Etc/GMT+7',
  'Etc/GMT+8',
  'Etc/GMT+9',
  'Etc/GMT-0',
  'Etc/GMT-1',
  'Etc/GMT-10',
  'Etc/GMT-11',
  'Etc/GMT-12',
  'Etc/GMT-13',
  'Etc/GMT-14',
  'Etc/GMT-2',
  'Etc/GMT-3',
  'Etc/GMT-4',
  'Etc/GMT-5',
  'Etc/GMT-6',
  'Etc/GMT-7',
  'Etc/GMT-8',
  'Etc/GMT-9',
  'Etc/GMT0',
  'Etc/Greenwich',
  'Etc/UCT',
  'Etc/UTC',
  'Etc/Universal',
  'Etc/Zulu',
  'Europe/Amsterdam',
  'Europe/Andorra',
  'Europe/Astrakhan',
  'Europe/Athens',
  'Europe/Belfast',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Bratislava',
  'Europe/Brussels',
  'Europe/Bucharest',
  'Europe/Budapest',
  'Europe/Busingen',
  'Europe/Chisinau',
  'Europe/Copenhagen',
  'Europe/Dublin',
  'Europe/Gibraltar',
  'Europe/Guernsey',
  'Europe/Helsinki',
  'Europe/Isle_of_Man',
  'Europe/Istanbul',
  'Europe/Jersey',
  'Europe/Kaliningrad',
  'Europe/Kiev',
  'Europe/Kirov',
  'Europe/Lisbon',
  'Europe/Ljubljana',
  'Europe/London',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Mariehamn',
  'Europe/Minsk',
  'Europe/Monaco',
  'Europe/Moscow',
  'Europe/Nicosia',
  'Europe/Oslo',
  'Europe/Paris',
  'Europe/Podgorica',
  'Europe/Prague',
  'Europe/Riga',
  'Europe/Rome',
  'Europe/Samara',
  'Europe/San_Marino',
  'Europe/Sarajevo',
  'Europe/Saratov',
  'Europe/Simferopol',
  'Europe/Skopje',
  'Europe/Sofia',
  'Europe/Stockholm',
  'Europe/Tallinn',
  'Europe/Tirane',
  'Europe/Tiraspol',
  'Europe/Ulyanovsk',
  'Europe/Uzhgorod',
  'Europe/Vaduz',
  'Europe/Vatican',
  'Europe/Vienna',
  'Europe/Vilnius',
  'Europe/Volgograd',
  'Europe/Warsaw',
  'Europe/Zagreb',
  'Europe/Zaporozhye',
  'Europe/Zurich',
  'GB',
  'GB-Eire',
  'GMT',
  'GMT+0',
  'GMT-0',
  'GMT0',
  'Greenwich',
  'HST',
  'Hongkong',
  'Iceland',
  'Indian/Antananarivo',
  'Indian/Chagos',
  'Indian/Christmas',
  'Indian/Cocos',
  'Indian/Comoro',
  'Indian/Kerguelen',
  'Indian/Mahe',
  'Indian/Maldives',
  'Indian/Mauritius',
  'Indian/Mayotte',
  'Indian/Reunion',
  'Iran',
  'Israel',
  'Jamaica',
  'Japan',
  'Kwajalein',
  'Libya',
  'MET',
  'MST',
  'MST7MDT',
  'Mexico/BajaNorte',
  'Mexico/BajaSur',
  'Mexico/General',
  'NZ',
  'NZ-CHAT',
  'Navajo',
  'PRC',
  'PST8PDT',
  'Pacific/Apia',
  'Pacific/Auckland',
  'Pacific/Bougainville',
  'Pacific/Chatham',
  'Pacific/Chuuk',
  'Pacific/Easter',
  'Pacific/Efate',
  'Pacific/Enderbury',
  'Pacific/Fakaofo',
  'Pacific/Fiji',
  'Pacific/Funafuti',
  'Pacific/Galapagos',
  'Pacific/Gambier',
  'Pacific/Guadalcanal',
  'Pacific/Guam',
  'Pacific/Honolulu',
  'Pacific/Johnston',
  'Pacific/Kiritimati',
  'Pacific/Kosrae',
  'Pacific/Kwajalein',
  'Pacific/Majuro',
  'Pacific/Marquesas',
  'Pacific/Midway',
  'Pacific/Nauru',
  'Pacific/Niue',
  'Pacific/Norfolk',
  'Pacific/Noumea',
  'Pacific/Pago_Pago',
  'Pacific/Palau',
  'Pacific/Pitcairn',
  'Pacific/Pohnpei',
  'Pacific/Ponape',
  'Pacific/Port_Moresby',
  'Pacific/Rarotonga',
  'Pacific/Saipan',
  'Pacific/Samoa',
  'Pacific/Tahiti',
  'Pacific/Tarawa',
  'Pacific/Tongatapu',
  'Pacific/Truk',
  'Pacific/Wake',
  'Pacific/Wallis',
  'Pacific/Yap',
  'Poland',
  'Portugal',
  'ROC',
  'ROK',
  'Singapore',
  'Turkey',
  'UCT',
  'US/Alaska',
  'US/Aleutian',
  'US/Arizona',
  'US/Central',
  'US/East-Indiana',
  'US/Eastern',
  'US/Hawaii',
  'US/Indiana-Starke',
  'US/Michigan',
  'US/Mountain',
  'US/Pacific',
  'US/Pacific-New',
  'US/Samoa',
  'UTC',
  'Universal',
  'W-SU',
  'WET',
  'Zulu',
];

export const objectType = {
  1: 0,
  2: 2,
  3: 3,
  4: 6,
  5: 4,
  6: 2,
  7: 3,
  8: 5,
};
export const Reviewstatus = {
  Feedback: 1,
  Review: 2,
  Replied: 3,
  SharedtoGoogle: 4,
};

export const ReviewAction = {
  ActionNoAction: 1,
  ActionInProgress: 2,
  ActionTodo: 3,
  ActionTaken: 4,
};
export const regularExpressions = {
  name: /^[A-Za-z\s]+$/,
  email: /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
  webSite: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
  twitter: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
  facebook: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
  gmb: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
  linkedin: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
  yelp: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
  tripadvisor: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
  link: /^(http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/,
  phonenumber: /^(\\+)?[1-9]{1}[0-9]{0,2}[0-9]{1}[0-9]{2}[0-9]{1}[0-9]{2}[0-9]{4}$/,
};
export const Icons = {
  Workspace: <svg width="25" height="25" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.25 3.68468C0.25 1.78235 1.79463 0.25 3.68468 0.25H26.3243C28.2177 0.25 29.75 1.78563 29.75 3.68468V17.5315C29.75 19.4232 28.216 20.9572 26.3243 20.9572H24.3423V19.4572H26.3243C27.3876 19.4572 28.25 18.5948 28.25 17.5315V3.68468C28.25 2.61077 27.3859 1.75 26.3243 1.75H3.68468C2.61978 1.75 1.75 2.61405 1.75 3.68468V17.5315C1.75 18.5915 2.61814 19.4572 3.68468 19.4572H6.07207V20.9572H3.68468C1.79628 20.9572 0.25 19.4265 0.25 17.5315V3.68468Z" fill="#005EB2" />
    <path fillRule="evenodd" clipRule="evenodd" d="M15.0002 8.58789C13.3645 8.58789 12.0385 9.91389 12.0385 11.5496C12.0385 13.1853 13.3645 14.5113 15.0002 14.5113C16.6359 14.5113 17.9619 13.1853 17.9619 11.5496C17.9619 9.91389 16.6359 8.58789 15.0002 8.58789ZM10.5385 11.5496C10.5385 9.08547 12.536 7.08789 15.0002 7.08789C17.4643 7.08789 19.4619 9.08547 19.4619 11.5496C19.4619 14.0137 17.4643 16.0113 15.0002 16.0113C12.536 16.0113 10.5385 14.0137 10.5385 11.5496Z" fill="#005EB2" />
    <path fillRule="evenodd" clipRule="evenodd" d="M6.85846 25.232H23.1417C22.7655 21.3679 19.513 18.3536 15.5586 18.3536H14.4505C10.4872 18.3536 7.23464 21.3683 6.85846 25.232ZM5.32214 25.982C5.32214 20.9372 9.40568 16.8536 14.4505 16.8536H15.5586C20.595 16.8536 24.678 20.9377 24.678 25.982V26.732H5.32214V25.982Z" fill="#005EB2" />
  </svg>,
  'Marketing Central': <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M22.59 4.79607C22.8433 4.94409 22.902 5.23209 22.7211 5.43932L21.3121 7.05324C21.1312 7.26047 20.7792 7.30847 20.5259 7.16045C20.2726 7.01243 20.214 6.72443 20.3949 6.5172L21.8038 4.90328C21.9848 4.69605 22.3368 4.64805 22.59 4.79607Z" fill="#005EB2" />
    <path fillRule="evenodd" clipRule="evenodd" d="M20.8545 14.2164C20.6374 14.3644 20.5871 14.6524 20.7422 14.8596L21.9499 16.4735C22.1049 16.6808 22.4066 16.7288 22.6237 16.5807C22.8408 16.4327 22.8911 16.1447 22.7361 15.9375L21.5284 14.3236C21.3733 14.1163 21.0716 14.0683 20.8545 14.2164Z" fill="#005EB2" />
    <path fillRule="evenodd" clipRule="evenodd" d="M17.4452 2.37811C17.697 2.27898 17.8192 1.99849 17.7181 1.75162C17.617 1.50474 17.3308 1.38496 17.0789 1.48409L0.861209 7.86659L0.658735 7.94627L0.583236 8.14692L1.04432 8.3136C0.583236 8.14692 0.583216 8.14697 0.583193 8.14703L0.583138 8.14718L0.582988 8.14758L0.58254 8.14877L0.581053 8.15276L0.575812 8.16693C0.571344 8.17907 0.564969 8.19654 0.556961 8.21886C0.54095 8.26348 0.518373 8.32758 0.49142 8.40732C0.437601 8.56657 0.365889 8.78954 0.294056 9.04537C0.153654 9.5454 0 10.2146 0 10.7823C0 11.3463 0.152234 12.0586 0.291347 12.5995C0.362577 12.8764 0.433684 13.1207 0.486999 13.2959C0.513693 13.3836 0.536022 13.4543 0.551801 13.5034C0.559693 13.528 0.565954 13.5472 0.570312 13.5605L0.57539 13.5759L0.576797 13.5801L0.577206 13.5813L0.577336 13.5817L0.577381 13.5818C0.577399 13.5819 0.577415 13.5819 1.04432 13.4316L0.577415 13.5819L0.647322 13.7906L0.853844 13.8757L6.02022 16.0048V18.0078V18.0345L6.02322 18.061L6.51166 18.0078C6.02322 18.061 6.0233 18.0617 6.02338 18.0624L6.02355 18.0638L6.02391 18.0667L6.02469 18.0727C6.02525 18.0767 6.02587 18.0809 6.02657 18.0852C6.02797 18.0937 6.02965 18.1028 6.03168 18.1124C6.03575 18.1315 6.04116 18.1524 6.04829 18.1749C6.06257 18.2202 6.08347 18.2714 6.1135 18.3277C6.17355 18.4404 6.26877 18.5713 6.41756 18.7172C6.71233 19.0061 7.23067 19.3665 8.15356 19.772C8.31275 19.8419 8.46622 19.9103 8.61302 19.9758L8.61339 19.9759C8.86698 20.0889 9.10068 20.1931 9.30961 20.281C9.64078 20.4205 9.94996 20.537 10.2359 20.5999C10.5267 20.6638 10.826 20.6798 11.1224 20.5866C11.4218 20.4924 11.6622 20.3045 11.8673 20.0597C12.0612 19.8283 12.1362 19.5497 12.1625 19.3104C12.1892 19.0673 12.1704 18.8218 12.1394 18.6137C12.1347 18.5821 12.1297 18.551 12.1244 18.5204L17.0716 20.5592C17.3218 20.6624 17.6099 20.5471 17.7151 20.3019C17.8203 20.0567 17.7027 19.7743 17.4525 19.6712L1.44538 13.0744C1.44012 13.0573 1.43461 13.0393 1.42887 13.0205C1.37852 12.8551 1.31141 12.6244 1.24442 12.364C1.1071 11.83 0.982892 11.2177 0.982892 10.7823C0.982892 10.3507 1.10568 9.78549 1.24171 9.30101C1.3081 9.06458 1.37461 8.85776 1.42445 8.71027C1.4281 8.69948 1.43166 8.68901 1.43511 8.67888L17.4452 2.37811ZM7.11257 18.036C7.05512 17.9797 7.0216 17.9374 7.00311 17.9109V16.4778L11.081 18.3529C11.1107 18.4604 11.1443 18.6015 11.1668 18.7528C11.191 18.9153 11.1999 19.0734 11.1852 19.2072C11.1701 19.3446 11.1347 19.4161 11.1078 19.4482C10.9854 19.5942 10.8931 19.6469 10.822 19.6693C10.748 19.6926 10.6389 19.7011 10.4511 19.6598C10.2584 19.6175 10.0185 19.531 9.69753 19.3959C9.49679 19.3113 9.28003 19.2147 9.03473 19.1054L9.03469 19.1053L9.03456 19.1053C8.88626 19.0392 8.72754 18.9684 8.55561 18.8929C7.69701 18.5156 7.29389 18.2137 7.11257 18.036Z" fill="#005EB2" />
    <path fillRule="evenodd" clipRule="evenodd" d="M22.8309 18.1891C23.5606 16.3649 24.0338 13.7775 24.0338 10.8696C24.0338 7.96165 23.5606 5.37425 22.8309 3.54999C22.465 2.63531 22.0536 1.96021 21.6463 1.52947C21.2413 1.10121 20.9053 0.97704 20.6522 0.97704C20.3991 0.97704 20.0631 1.10121 19.6581 1.52947C19.2507 1.96021 18.8394 2.63531 18.4735 3.54999C17.7438 5.37425 17.2705 7.96165 17.2705 10.8696C17.2705 13.7775 17.7438 16.3649 18.4735 18.1891C18.8394 19.1038 19.2507 19.7789 19.6581 20.2097C20.0631 20.6379 20.3991 20.7621 20.6522 20.7621C20.9053 20.7621 21.2413 20.6379 21.6463 20.2097C22.0536 19.7789 22.465 19.1038 22.8309 18.1891ZM20.6522 21.7391C23.0534 21.7391 25 16.8727 25 10.8696C25 4.86647 23.0534 0 20.6522 0C18.2509 0 16.3044 4.86647 16.3044 10.8696C16.3044 16.8727 18.2509 21.7391 20.6522 21.7391Z" fill="#005EB2" />
    <path fillRule="evenodd" clipRule="evenodd" d="M18.6017 8.13888C18.7921 7.94268 19.1341 7.91436 19.3657 8.07562C20.4039 8.79852 21.0145 9.80055 21.0145 10.8696C21.0145 11.9386 20.4039 12.9406 19.3657 13.6635C19.1341 13.8248 18.7921 13.7964 18.6017 13.6002C18.4114 13.404 18.4448 13.1143 18.6764 12.953C19.4959 12.3823 19.9289 11.6299 19.9289 10.8696C19.9289 10.1092 19.4959 9.35678 18.6764 8.78612C18.4448 8.62486 18.4114 8.33508 18.6017 8.13888Z" fill="#005EB2" />
    <path fillRule="evenodd" clipRule="evenodd" d="M21.3768 11.0507C21.3768 10.7506 21.5931 10.5072 21.8599 10.5072L23.0676 10.5072C23.3344 10.5072 23.5507 10.7506 23.5507 11.0507C23.5507 11.3509 23.3344 11.5942 23.0676 11.5942L21.8599 11.5942C21.5931 11.5942 21.3768 11.3509 21.3768 11.0507Z" fill="#005EB2" />
  </svg>,
  'Product & Service': <svg width="25" height="25" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M13.5247 0V4.47671H14.9753V0H13.5247ZM8.53244 5.75138L6.9314 1.36794L8.29395 0.870265L9.895 5.25371L8.53244 5.75138ZM0.386466 4.90018L2.9357 8.44424L4.1133 7.59719L1.56407 4.05313L0.386466 4.90018ZM13.8686 8H14.1314L27.4463 11.4798L27.4772 11.4906C27.9466 11.655 28.0999 12.0997 27.9372 12.4473C27.9812 12.5483 28 12.653 28 12.7479V26.8134C28 26.9409 27.9662 27.0988 27.8586 27.2457C27.7536 27.3891 27.6133 27.4739 27.4829 27.5188L15.0204 31.959L15.0111 31.962C14.8055 32.0289 14.621 31.998 14.4828 31.9423C14.3346 31.998 14.137 32.0289 13.9167 31.962L13.9067 31.959L0.554029 27.5189C0.414288 27.474 0.264047 27.3892 0.151467 27.2457C0.0362106 27.0989 0 26.9409 0 26.8135V12.7482C0 12.6416 0.0240459 12.5425 0.0658786 12.4537C-0.101761 12.1052 0.0505405 11.656 0.522783 11.4906L0.553739 11.4798L13.8686 8ZM14 9.31289L3.18858 12.1384L14 14.6916L24.8114 12.1384L14 9.31289ZM14 16.6098L13.9724 16.603C13.9814 16.6057 13.9906 16.6083 14 16.6106V16.6098ZM1.47766 26.3942V13.5274L13.5223 16.4922V30.3994L1.47766 26.3942ZM15.3792 16.492L26.6208 13.5271V26.3941L15.3792 30.3994V16.492ZM19.1639 5.25583L20.7494 0.87239L22.1135 1.36579L20.528 5.74923L19.1639 5.25583ZM26.6098 4.06718L24.1849 7.61124L25.3821 8.43037L27.807 4.88631L26.6098 4.06718Z" fill="#005EB2" />
  </svg>,
  'Professional Services': <svg width="25" height="25" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.603 0C16.2257 0.140616 16.8616 0.236434 17.4686 0.431803C20.3914 1.36883 22.0604 3.54775 22.9546 6.45091C23.0958 6.91134 23.2237 7.22617 23.7558 7.34065C24.3882 7.47753 24.7273 8.00018 24.7345 8.66841C24.7538 10.2438 24.7611 11.8192 24.7345 13.3946C24.7201 14.2507 24.1432 14.802 23.3069 14.8331C22.8894 14.8493 22.4707 14.8356 21.9759 14.8356C21.9759 14.5631 21.9759 14.3416 21.9759 14.1213C21.9759 12.2348 21.9155 10.3458 21.994 8.46309C22.0676 6.68984 21.3954 5.24012 20.4011 3.90489C18.5957 1.48456 16.0881 0.951958 13.3355 1.31034C11.2309 1.58535 9.41714 2.50247 8.17176 4.36656C7.44891 5.44794 7.05913 6.64379 7.06758 7.9728C7.07964 9.88045 7.06637 11.7869 7.0724 13.6945C7.07723 15.6171 8.46018 17.3194 10.2932 17.6044C10.5575 17.6454 10.9232 17.5185 11.1307 17.3343C12.0418 16.5292 14.0233 16.5541 14.8729 17.4277C15.3423 17.9105 15.323 18.4095 14.8174 18.8662C13.8809 19.7111 12.0925 19.7111 11.1331 18.8799C11.0076 18.7704 10.829 18.6758 10.6698 18.6646C8.52776 18.514 7.15808 17.292 6.36524 15.3234C6.21198 14.9439 6.05149 14.8368 5.68222 14.8244C4.87128 14.797 4.33185 14.2383 4.32099 13.3983C4.29686 11.8229 4.29565 10.2463 4.31979 8.6709C4.33306 7.77619 4.84111 7.32074 5.86926 7.19381C6.04304 6.56664 6.16975 5.91831 6.40024 5.31105C7.4996 2.40292 9.69711 0.888494 12.5595 0.250122C13.0072 0.150571 13.4622 0.0833741 13.9135 0C14.4771 0 15.0394 0 15.603 0Z" fill="#005EB2" />
    <path d="M17.1718 27.9988C17.92 25.938 18.6658 23.8773 19.4164 21.8179C19.6601 21.1496 19.9111 20.4839 20.1778 19.7671C22.0036 20.9866 23.9501 21.7706 25.9485 22.4326C27.2325 22.8569 27.9807 23.6944 27.9397 25.1541C27.9337 25.3544 28 25.5573 28.0326 25.7589C28.0326 26.5055 28.0326 27.2521 28.0326 27.9988C24.4123 27.9988 20.7921 27.9988 17.1718 27.9988Z" stroke="#005EB2" strokeMiterlimit="10" />
    <path d="M1.00121 27.6254C1.04224 26.9696 1.10499 26.3126 1.11826 25.6568C1.15084 24.0851 1.4103 23.7019 2.80652 23.0921C4.87973 22.1875 6.9445 21.2579 9.06598 20.3159C9.38698 21.1646 9.76228 22.1514 10.1315 23.1407C10.6637 24.5617 11.1947 25.9841 11.7184 27.4089C11.7872 27.5968 11.815 27.8009 11.8608 27.9988C8.24056 27.9988 4.62028 27.9988 1 27.9988C1.00121 27.8731 1.00121 27.7486 1.00121 27.6254Z" stroke="#005EB2" strokeMiterlimit="10" />
    <path d="M12.9481 27.9988C13.1979 26.6225 13.4477 25.2474 13.6855 23.9408C13.3379 23.7504 12.8347 23.6384 12.7804 23.4119C12.6501 22.8694 12.6706 22.2621 12.7611 21.7034C12.79 21.5267 13.2221 21.3226 13.4827 21.3015C14.1814 21.2455 14.8874 21.2815 15.5897 21.2828C16.1038 21.284 16.3669 21.5566 16.391 22.0792C16.3995 22.2646 16.3971 22.4513 16.3958 22.6379C16.3922 23.5961 16.3029 23.7044 15.3279 23.8313C15.5813 25.2238 15.8335 26.6113 16.0857 28C15.0394 27.9988 13.9944 27.9988 12.9481 27.9988Z" stroke="#005EB2" strokeMiterlimit="10" />
    <path d="M14.3431 20.4105C14.7836 20.1379 15.1492 19.965 15.4533 19.7124C16.5503 18.8052 16.5093 17.3816 15.3918 16.4832C14.2273 15.5474 12.0467 15.2537 10.4212 16.5641C10.3644 16.4906 10.2969 16.4234 10.251 16.3438C9.82019 15.5872 9.42558 14.8306 8.85841 14.14C7.893 12.9653 7.74578 11.4758 7.893 9.97129C7.9099 9.79707 7.98954 9.52953 8.1078 9.481C8.59533 9.28314 8.49276 8.8812 8.47828 8.51535C8.32743 4.80956 11.0704 2.56219 14.2888 2.48753C16.3584 2.439 18.1686 3.07115 19.4936 4.80583C20.3395 5.91458 20.6122 7.20999 20.5591 8.59624C20.5471 8.92351 20.4542 9.27194 20.9067 9.44616C21.0443 9.49842 21.136 9.83316 21.1492 10.046C21.2603 11.8142 20.9284 13.3672 19.6806 14.7709C18.9686 15.571 18.609 16.7769 18.3013 17.8632C18.0708 18.6783 17.7486 19.3179 17.0607 19.7385C16.2667 20.2251 15.387 20.4067 14.3431 20.4105Z" stroke="#005EB2" strokeMiterlimit="10" />
  </svg>,
  'Sales Central': <SvgIcon
    color="primary"
    style={SvgStyle}
    viewBox="0 -18 512.00048 512"
  >
    <g id="Email_maketing" data-name="Email maketing">
      <path d="m230.367188 316.371094c3.902343-3.910156 3.902343-10.242188 0-14.152344-3.910157-3.898438-10.238282-3.898438-14.148438 0-3.902344 3.910156-3.902344 10.242188 0 14.152344 3.910156 3.898437 10.238281 3.898437 14.148438 0zm0 0" />
      <path d="m234.007812 81.003906v20c0 33.148438 26.851563 60 60 60 33.085938 0 60.003907-26.914062 60.003907-60v-20c5.523437 0 10-4.476562 10-10 0-5.523437-4.476563-10-10-10h-20c-5.523438 0-10 4.476563-10 10 0 5.523438 4.476562 10 10 10v20c0 22.054688-17.945313 40-40.003907 40-22.089843 0-40-17.902344-40-40v-20c5.523438 0 10-4.476562 10-10 0-5.523437-4.476562-10-10-10h-20c-5.523437 0-10 4.476563-10 10 0 5.523438 4.476563 10 10 10zm0 0" />
      <path d="m116.21875 472.941406c1.953125 1.949219 4.507812 2.921875 7.066406 2.921875s5.117188-.976562 7.070313-2.925781l30.707031-30.707031c10.003906-9.996094 14.820312-23.6875 13.429688-37.523438l11.011718-10.632812c8.738282-8.421875 20.226563-13.0625 32.34375-13.0625h131.664063c23.585937 0 45.878906-9.058594 62.769531-25.507813.25-.242187.484375-.496094.707031-.765625l89.585938-107.578125c14.234375-16.84375 12.105469-42.132812-4.753907-56.382812-16.75-14.117188-41.851562-12.085938-56.128906 4.476562l-9.675781 10.007813v-195.261719c0-5.523438-4.480469-10-10-10h-257.011719c-5.519531 0-10 4.476562-10 10v224.050781c-38.726562 8.128907-69.441406 32.167969-85.984375 67.308594-13.046875-.675781-25.769531 4.121094-35.210937 13.574219l-30.863282 30.710937c-1.882812 1.875-2.94140575 4.421875-2.945312 7.078125-.00390625 2.660156 1.054688 5.207032 2.933594 7.085938zm295.796875-452.941406v205.941406l-28.941406 29.921875c-7.449219-9.152343-18.800781-14.855469-31.0625-14.855469h-115.945313c-.640625 0-1.335937-.148437-2.035156-.429687-15.578125-6.351563-32.074219-9.570313-49.023438-9.570313-3.347656 0-6.683593.121094-10 .339844v-211.347656zm-245.578125 232.324219c20.230469-2.925781 40.460938-1.207031 60.082031 6.789062 3.117188 1.257813 6.332031 1.898438 9.546875 1.898438h115.945313c10.84375 0 20 8.84375 20 20 0 11.027343-8.972657 20-20 20h-87.003907c-5.519531 0-10 4.476562-10 10 0 5.523437 4.480469 10 10 10h87.003907c22.058593 0 40-17.945313 40-40 0-1.765625-.128907-3.519531-.355469-5.25 2.085938-2.136719 62.53125-64.652344 64.625-66.820313.152344-.160156.304688-.324218.445312-.492187 7.125-8.414063 19.777344-9.476563 28.195313-2.382813 8.425781 7.121094 9.492187 19.765625 2.328125 28.242188l-89.285156 107.21875c-13.089844 12.570312-30.277344 19.484375-48.453125 19.484375h-131.664063c-17.324218 0-33.738281 6.625-46.230468 18.667969l-4.410157 4.257812c-1.765625-2.714844-3.820312-5.25-6.140625-7.566406l-61.421875-61.421875c-3.28125-3.28125-7.003906-6.007813-11.03125-8.160157 15.277344-30.132812 42.566407-49.339843 77.824219-54.464843zm-118.5 76.765625c10.507812-10.523438 27.300781-10.265625 37.5625.003906l61.429688 61.425781c10.296874 10.277344 10.480468 27.089844-.003907 37.5625l-23.648437 23.644531-99.113282-98.980468zm0 0" />
    </g>

  </SvgIcon>,
  'Contact Central': <SvgIcon
    color="primary"
    style={SvgStyle}
    viewBox="-49 -17 560 560"
  >
    <path d="m397.667969 0h-295.375c-34.511719.015625-62.488281 27.988281-62.5 62.5v27h-29.375c-6.90625 0-12.5 5.597656-12.5 12.5s5.59375 12.5 12.5 12.5h29.246093v82h-29.246093c-6.90625 0-12.5 5.59375-12.5 12.5 0 6.902344 5.59375 12.5 12.5 12.5h29.246093v82h-29.246093c-6.90625 0-12.5 5.597656-12.5 12.5 0 6.90625 5.59375 12.5 12.5 12.5h29.246093v82h-29.246093c-6.90625 0-12.5 5.597656-12.5 12.5s5.59375 12.5 12.5 12.5h29.246093v27c.015626 34.511719 27.988282 62.484375 62.5 62.5h295.375c34.511719-.015625 62.492188-27.988281 62.5-62.5v-400c.050782-34.488281-27.882812-62.4765625-62.371093-62.5zm37.5 462.5c-.0625 20.683594-16.816407 37.441406-37.5 37.5h-295.375c-20.683594-.058594-37.441407-16.816406-37.5-37.5v-27h29.246093c6.90625 0 12.5-5.597656 12.5-12.5s-5.59375-12.5-12.5-12.5h-29.246093v-82h29.246093c6.90625 0 12.5-5.59375 12.5-12.5 0-6.902344-5.59375-12.5-12.5-12.5h-29.246093v-82h29.246093c6.90625 0 12.5-5.597656 12.5-12.5 0-6.90625-5.59375-12.5-12.5-12.5h-29.246093v-82h29.246093c6.90625 0 12.5-5.597656 12.5-12.5s-5.59375-12.5-12.5-12.5h-29.246093v-27c.058593-20.683594 16.816406-37.441406 37.5-37.5h295.375c20.683593.058594 37.4375 16.816406 37.5 37.5zm0 0" />
    <path d="m249.917969 258.875c33.480469 0 60.625-27.140625 60.625-60.625s-27.144531-60.625-60.625-60.625c-33.484375 0-60.625 27.140625-60.625 60.625.03125 33.46875 27.152343 60.59375 60.625 60.625zm0-96.375c19.671875 0 35.625 15.953125 35.625 35.625s-15.953125 35.625-35.625 35.625c-19.675781 0-35.625-15.953125-35.625-35.625.035156-19.65625 15.960937-35.589844 35.625-35.625zm0 0" />
    <path d="m249.917969 279c-52 0-92.753907 42.125-92.753907 96 .019532 6.894531 5.605469 12.480469 12.5 12.5h160.503907c6.894531-.019531 12.480469-5.605469 12.5-12.5 0-53.875-40.753907-96-92.75-96zm-66.753907 83.5c5.378907-34.125 32.253907-58.5 66.753907-58.5 34.496093 0 61.5 24.375 66.75 58.5zm0 0" />
  </SvgIcon>,
  'Lead Central': <SvgIcon
    color="primary"
    style={SvgStyle}
    viewBox="0 0 512 512"
  >
    <g>
      <g>
        <path d="M460.934,268.491c4.524-6.708,7.168-14.784,7.168-23.466v-8.021c0-23.203-18.878-42.081-42.081-42.081
c-11.577,0-22.077,4.701-29.693,12.293C376.622,148.609,321.163,106.275,256,106.275s-120.622,42.333-140.328,100.941
c-7.616-7.592-18.115-12.293-29.693-12.293c-23.203,0-42.081,18.878-42.081,42.081v8.021c0,8.682,2.644,16.758,7.168,23.466
C21.937,274.629,0,300.524,0,331.452v20.134c0,5.522,4.478,10,10,10h52c5.522,0,10-4.478,10-10c0-5.522-4.478-10-10-10H20v-10.134
c0-24.453,19.894-44.347,44.347-44.347h47.329c3.838,16.881,10.565,32.677,19.641,46.831L17.218,448.035
c-14.61,14.611-14.61,38.386,0.001,52.998c7.306,7.306,16.901,10.958,26.498,10.958c9.597,0,19.194-3.653,26.5-10.958
l62.903-62.904c3.905-3.905,3.905-10.237,0-14.143c-3.906-3.904-10.236-3.904-14.143,0L56.075,486.89
c-6.815,6.814-17.901,6.813-24.715,0.001c-6.813-6.814-6.813-17.901,0-24.715L143.367,350.17
c27.167,31.862,67.578,52.105,112.633,52.105c70.328,0,129.35-49.31,144.324-115.17h47.329c24.453,0,44.347,19.894,44.347,44.347
v10.134h-94c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10h104c5.522,0,10-4.478,10-10v-20.134
C512,300.524,490.063,274.629,460.934,268.491z M108.06,245.026c0,12.175-9.905,22.08-22.081,22.08s-22.081-9.905-22.081-22.08
v-8.021c0-12.176,9.905-22.081,22.081-22.081c12.176,0,22.081,9.905,22.081,22.081V245.026z M256,382.275
c-70.579,0-128-57.421-128-128s57.421-128,128-128s128,57.421,128,128S326.579,382.275,256,382.275z M448.101,245.026
c0,12.175-9.905,22.08-22.081,22.08c-12.176,0-22.081-9.905-22.081-22.08v-8.021c0-12.176,9.905-22.081,22.081-22.081
c12.176,0,22.081,9.905,22.081,22.081V245.026z"
        />
      </g>
    </g>
    <g>
      <g>
        <path d="M256,146.275c-59.552,0-108,48.448-108,108c0,30.91,13.056,58.825,33.938,78.53c0.357,0.386,0.74,0.75,1.16,1.08
c19.226,17.621,44.829,28.39,72.902,28.39s53.676-10.77,72.902-28.39c0.42-0.329,0.803-0.694,1.16-1.08
C350.944,313.1,364,285.185,364,254.275C364,194.724,315.552,146.275,256,146.275z M256,342.275
c-20.563,0-39.499-7.091-54.497-18.954c10.625-20.104,31.331-32.753,54.497-32.753s43.872,12.649,54.497,32.753
C295.499,335.184,276.563,342.275,256,342.275z M234.927,249.495v-7.769c0-11.62,9.453-21.073,21.073-21.073
s21.073,9.453,21.073,21.073v7.769c0,11.62-9.453,21.073-21.073,21.073S234.927,261.115,234.927,249.495z M325.125,308.674
c-9.161-14.617-22.57-25.764-38.264-32.12c6.349-7.233,10.212-16.7,10.212-27.058v-7.769c0-22.647-18.426-41.073-41.073-41.073
c-22.647,0-41.073,18.426-41.073,41.073v7.769c0,10.358,3.862,19.825,10.212,27.058c-15.694,6.357-29.102,17.503-38.264,32.12
C175.059,293.692,168,274.793,168,254.275c0-48.523,39.477-88,88-88s88,39.477,88,88C344,274.793,336.941,293.692,325.125,308.674
z"
        />
      </g>
    </g>
    <g>
      <g>
        <path d="M159.87,397.239c-1.86-1.86-4.44-2.93-7.07-2.93s-5.21,1.07-7.07,2.93c-1.859,1.86-2.93,4.44-2.93,7.07
s1.07,5.21,2.93,7.07c1.86,1.859,4.44,2.93,7.07,2.93s5.21-1.07,7.07-2.93c1.859-1.86,2.93-4.44,2.93-7.07
S161.73,399.099,159.87,397.239z"
        />
      </g>
    </g>
    <g>
      <g>
        <path d="M256.203,0.009c-5.522,0-10,4.478-10,10v34.024c0,5.523,4.478,10,10,10c5.522,0,10-4.478,10-10V10.009
C266.203,4.487,261.725,0.009,256.203,0.009z"
        />
      </g>
    </g>
    <g>
      <g>
        <path d="M263.269,69.939c-1.859-1.86-4.43-2.93-7.069-2.93c-2.631,0-5.21,1.069-7.07,2.93c-1.86,1.861-2.93,4.44-2.93,7.07
c0,2.63,1.069,5.21,2.93,7.069c1.86,1.86,4.439,2.931,7.07,2.931c2.64,0,5.21-1.07,7.069-2.931
c1.86-1.859,2.931-4.439,2.931-7.069C266.2,74.379,265.13,71.799,263.269,69.939z"
        />
      </g>
    </g>
    <g>
      <g>
        <path d="M340.979,39.235c-3.906-3.904-10.236-3.904-14.143,0L309.26,56.811c-3.905,3.905-3.905,10.237,0,14.143
c1.954,1.952,4.512,2.929,7.072,2.929s5.118-0.977,7.071-2.929l17.576-17.576C344.884,49.473,344.884,43.141,340.979,39.235z"
        />
      </g>
    </g>
    <g>
      <g>
        <path d="M202.908,56.932l-17.745-17.745c-3.906-3.904-10.236-3.904-14.143,0c-3.905,3.905-3.905,10.237,0,14.143l17.746,17.745
c1.953,1.952,4.512,2.929,7.071,2.929c2.559,0,5.118-0.977,7.071-2.929C206.813,67.17,206.813,60.838,202.908,56.932z"
        />
      </g>
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </SvgIcon>,
  'Reputation Central': <SvgIcon
    color="primary"
    style={SvgStyle}
    viewBox="0 0 512 512"
  >
    <g>
      <path d="m349.736 295.093c-8.548-9.68-20.844-15.232-33.736-15.232h-120c-12.892 0-25.188 5.552-33.736 15.232-2.025 2.294-2.454 5.588-1.083 8.324 18.103 36.135 54.436 58.583 94.819 58.583s76.716-22.448 94.82-58.583c1.37-2.736.942-6.03-1.084-8.324zm-93.736 51.907c-32.842 0-62.563-17.292-78.819-45.49 5.298-4.27 11.932-6.649 18.819-6.649h120c6.887 0 13.521 2.379 18.819 6.649-16.256 28.198-45.977 45.49-78.819 45.49z" />
      <path d="m221.509 223.909-5.354 32.223c-.466 2.802.692 5.627 2.99 7.297 1.306.949 2.854 1.432 4.409 1.432 1.181 0 2.366-.279 3.455-.843l28.991-15.051 28.991 15.05c2.522 1.309 5.566 1.081 7.864-.589 2.298-1.669 3.456-4.495 2.99-7.297l-5.355-32.223 23.272-22.922c2.024-1.993 2.748-4.959 1.87-7.661s-3.207-4.676-6.016-5.099l-32.301-4.865-14.608-29.216c-1.27-2.541-3.867-4.146-6.708-4.146s-5.438 1.605-6.708 4.146l-14.608 29.216-32.301 4.865c-2.809.423-5.138 2.397-6.016 5.099s-.154 5.668 1.87 7.661zm19.259-26.294c2.414-.364 4.5-1.879 5.591-4.063l9.641-19.281 9.641 19.282c1.091 2.183 3.177 3.699 5.591 4.063l21.318 3.21-15.359 15.128c-1.739 1.713-2.536 4.165-2.136 6.573l3.534 21.267-19.134-9.933c-2.167-1.124-4.744-1.124-6.911 0l-19.134 9.933 3.534-21.267c.4-2.408-.396-4.86-2.136-6.573l-15.359-15.128z" />
      <path d="m256 437c-20.678 0-37.5 16.822-37.5 37.5s16.822 37.5 37.5 37.5 37.5-16.822 37.5-37.5-16.822-37.5-37.5-37.5zm0 60c-12.407 0-22.5-10.093-22.5-22.5s10.093-22.5 22.5-22.5 22.5 10.093 22.5 22.5-10.093 22.5-22.5 22.5z" />
      <path d="m346.5 412.75c-17.907 10.339-24.064 33.319-13.726 51.226 6.938 12.017 19.569 18.743 32.54 18.743 6.357 0 12.797-1.616 18.687-5.017 17.907-10.339 24.064-33.319 13.726-51.226-10.341-17.907-33.32-24.065-51.227-13.726zm30 51.962c-10.745 6.202-24.533 2.508-30.736-8.236s-2.508-24.532 8.236-30.736c10.745-6.203 24.532-2.507 30.736 8.236 6.203 10.745 2.508 24.533-8.236 30.736z" />
      <path d="m463.977 332.774c-17.908-10.339-40.887-4.181-51.226 13.726-10.338 17.907-4.181 40.887 13.726 51.226 5.891 3.401 12.328 5.017 18.687 5.017 12.969 0 25.602-6.727 32.54-18.743 10.337-17.907 4.18-40.887-13.727-51.226zm.735 43.726c-6.204 10.745-19.991 14.438-30.736 8.236-10.744-6.204-14.439-19.992-8.236-30.736 6.204-10.745 19.991-14.44 30.736-8.236s14.44 19.992 8.236 30.736z" />
      <path d="m474.5 218.5c-20.678 0-37.5 16.822-37.5 37.5s16.822 37.5 37.5 37.5 37.5-16.822 37.5-37.5-16.822-37.5-37.5-37.5zm0 60c-12.407 0-22.5-10.093-22.5-22.5s10.093-22.5 22.5-22.5 22.5 10.093 22.5 22.5-10.093 22.5-22.5 22.5z" />
      <path d="m414.5 263.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-22.71c-1.054-19.301-6.151-37.542-14.457-53.892l19.682-11.363c3.587-2.071 4.816-6.658 2.745-10.245s-6.659-4.817-10.245-2.745l-19.707 11.378c-10.293-15.699-23.742-29.148-39.441-39.441l11.378-19.707c2.071-3.587.842-8.174-2.745-10.245-3.587-2.072-8.174-.842-10.245 2.745l-11.363 19.682c-16.349-8.306-34.591-13.403-53.892-14.457v-22.71c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v22.71c-19.301 1.054-37.542 6.151-53.892 14.457l-11.363-19.682c-2.071-3.587-6.658-4.816-10.245-2.745s-4.816 6.658-2.745 10.245l11.378 19.707c-15.699 10.293-29.148 23.742-39.441 39.441l-19.707-11.378c-3.587-2.073-8.174-.842-10.245 2.745s-.842 8.174 2.745 10.245l19.682 11.363c-8.306 16.349-13.403 34.591-14.457 53.892h-22.71c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h22.71c1.054 19.301 6.151 37.542 14.457 53.892l-19.682 11.363c-3.587 2.071-4.816 6.658-2.745 10.245 1.389 2.406 3.91 3.751 6.502 3.751 1.272 0 2.562-.324 3.743-1.006l19.707-11.378c10.293 15.699 23.742 29.148 39.441 39.441l-11.378 19.707c-2.071 3.587-.842 8.174 2.745 10.245 1.181.682 2.471 1.006 3.743 1.006 2.592 0 5.113-1.346 6.502-3.751l11.363-19.682c16.349 8.306 34.591 13.403 53.892 14.457v22.71c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-22.71c19.301-1.054 37.542-6.151 53.892-14.457l11.363 19.682c1.389 2.406 3.91 3.751 6.502 3.751 1.272 0 2.562-.324 3.743-1.006 3.587-2.071 4.816-6.658 2.745-10.245l-11.378-19.707c15.699-10.293 29.148-23.742 39.441-39.441l19.707 11.378c1.181.682 2.471 1.006 3.743 1.006 2.592 0 5.113-1.346 6.502-3.751 2.071-3.587.842-8.174-2.745-10.245l-19.682-11.363c8.306-16.349 13.403-34.591 14.457-53.892zm-158.5 113.5c-66.72 0-121-54.28-121-121s54.28-121 121-121 121 54.28 121 121-54.28 121-121 121z" />
      <path d="m445.29 184.243c6.357 0 12.797-1.616 18.687-5.017 17.907-10.339 24.064-33.319 13.726-51.226-10.34-17.907-33.319-24.065-51.226-13.726s-24.064 33.319-13.726 51.226c6.938 12.017 19.568 18.743 32.539 18.743zm-11.313-56.979c10.746-6.203 24.533-2.508 30.736 8.236s2.508 24.532-8.236 30.736c-10.745 6.204-24.533 2.508-30.736-8.236s-2.509-24.532 8.236-30.736z" />
      <path d="m346.5 99.25c5.891 3.401 12.328 5.017 18.687 5.017 12.969 0 25.602-6.727 32.54-18.743 10.338-17.907 4.181-40.887-13.726-51.226-17.908-10.34-40.887-4.182-51.226 13.726-10.339 17.906-4.182 40.886 13.725 51.226zm-.736-43.727c4.163-7.21 11.742-11.246 19.524-11.246 3.814 0 7.678.969 11.212 3.01 10.744 6.204 14.439 19.992 8.236 30.736-6.203 10.745-19.992 14.439-30.736 8.236s-14.439-19.991-8.236-30.736z" />
      <path d="m256 75c20.678 0 37.5-16.822 37.5-37.5s-16.822-37.5-37.5-37.5-37.5 16.822-37.5 37.5 16.822 37.5 37.5 37.5zm0-60c12.407 0 22.5 10.093 22.5 22.5s-10.093 22.5-22.5 22.5-22.5-10.093-22.5-22.5 10.093-22.5 22.5-22.5z" />
      <path d="m146.813 104.266c6.357 0 12.797-1.616 18.687-5.017 17.907-10.339 24.064-33.319 13.726-51.226-10.339-17.907-33.32-24.065-51.226-13.726-17.907 10.339-24.064 33.319-13.726 51.226 6.938 12.018 19.569 18.743 32.539 18.743zm-11.313-56.978c10.746-6.202 24.533-2.507 30.736 8.236 6.203 10.744 2.508 24.532-8.236 30.736-10.745 6.201-24.533 2.508-30.736-8.236-6.203-10.745-2.508-24.533 8.236-30.736z" />
      <path d="m48.023 179.226c5.891 3.401 12.328 5.017 18.687 5.017 12.969 0 25.602-6.727 32.54-18.743 10.338-17.907 4.181-40.887-13.726-51.226-17.908-10.34-40.887-4.182-51.226 13.726-10.339 17.907-4.182 40.887 13.725 51.226zm-.735-43.726c6.203-10.744 19.991-14.439 30.736-8.236 10.744 6.204 14.439 19.992 8.236 30.736-6.204 10.744-19.992 14.438-30.736 8.236-10.745-6.204-14.44-19.992-8.236-30.736z" />
      <path d="m75 256c0-20.678-16.822-37.5-37.5-37.5s-37.5 16.822-37.5 37.5 16.822 37.5 37.5 37.5 37.5-16.822 37.5-37.5zm-60 0c0-12.407 10.093-22.5 22.5-22.5s22.5 10.093 22.5 22.5-10.093 22.5-22.5 22.5-22.5-10.093-22.5-22.5z" />
      <path d="m48.023 332.774c-17.907 10.339-24.064 33.319-13.726 51.226 6.938 12.017 19.569 18.743 32.54 18.743 6.357 0 12.797-1.616 18.687-5.017 17.907-10.339 24.064-33.319 13.726-51.226-10.34-17.907-33.319-24.064-51.227-13.726zm30 51.962c-10.745 6.203-24.532 2.508-30.736-8.236-6.203-10.744-2.508-24.532 8.236-30.736 10.745-6.202 24.533-2.508 30.736 8.236s2.509 24.532-8.236 30.736z" />
      <path d="m165.5 412.75c-17.907-10.34-40.887-4.181-51.226 13.726-10.338 17.907-4.181 40.887 13.726 51.226 5.891 3.401 12.328 5.017 18.687 5.017 12.969 0 25.602-6.727 32.54-18.743 10.337-17.906 4.18-40.886-13.727-51.226zm.736 43.727c-6.204 10.745-19.991 14.44-30.736 8.236-10.744-6.204-14.439-19.992-8.236-30.736 6.204-10.745 19.992-14.439 30.736-8.236s14.439 19.991 8.236 30.736z" />
    </g>
  </SvgIcon>,
  'Promotion Central':
    <SvgIcon
      color="primary"
      style={SvgStyle}
      viewBox="0 0 612 612"
    >
      <path d="M263.793,0H31.655C14.139,0,0,14.14,0,31.656v232.138c0,17.516,14.139,31.655,31.655,31.655h232.138
c17.516,0,31.655-14.351,31.655-31.655V31.656C295.448,14.14,281.309,0,263.793,0z M274.345,263.794
c0,5.909-4.643,10.552-10.552,10.552H31.655c-5.909,0-10.552-4.643-10.552-10.552V31.656c0-5.909,4.643-10.552,10.552-10.552
h232.138c5.909,0,10.552,4.643,10.552,10.552V263.794z M580.345,0H348.207c-17.516,0-31.655,14.139-31.655,31.655v232.138
c0,17.516,14.139,31.655,31.655,31.655h232.138c17.516,0,31.655-14.351,31.655-31.655V31.656C612,14.14,597.861,0,580.345,0z
M590.896,263.794c0,5.909-4.643,10.552-10.552,10.552H348.207c-5.909,0-10.552-4.643-10.552-10.552V31.656
c0-5.909,4.643-10.552,10.552-10.552h232.138c5.909,0,10.552,4.643,10.552,10.552L590.896,263.794L590.896,263.794z
M263.793,316.552H31.655C14.139,316.552,0,330.691,0,348.207v232.138C0,597.861,14.139,612,31.655,612h232.138
c17.516,0,31.655-14.351,31.655-31.655V348.207C295.448,330.691,281.309,316.552,263.793,316.552z M274.345,580.345
c0,5.909-4.643,10.552-10.552,10.552H31.655c-5.909,0-10.552-4.643-10.552-10.552V348.207c0-5.909,4.643-10.552,10.552-10.552l0,0
h232.138c5.909,0,10.552,4.643,10.552,10.552V580.345z M580.345,316.552H348.207c-17.516,0-31.655,14.139-31.655,31.655v232.138
c0,17.516,14.139,31.655,31.655,31.655h232.138C597.861,612,612,597.649,612,580.345V348.207
C612,330.691,597.861,316.552,580.345,316.552z M590.896,580.345c0,5.909-4.643,10.552-10.552,10.552H348.207
c-5.909,0-10.552-4.643-10.552-10.552V348.207c0-5.909,4.643-10.552,10.552-10.552l0,0h232.138c5.909,0,10.552,4.643,10.552,10.552
L590.896,580.345L590.896,580.345z M121.345,52.759c0,2.954-2.321,5.276-5.276,5.276H58.034v58.034c0,2.742-2.321,5.276-5.276,5.276
c-2.954,0-5.276-2.321-5.276-5.276v-63.31c0-2.954,2.321-5.276,5.276-5.276h63.31C119.023,47.483,121.345,49.805,121.345,52.759z
M437.896,52.759c0,2.954-2.321,5.276-5.276,5.276h-58.034v58.034c0,2.742-2.321,5.276-5.276,5.276
c-2.954,0-5.276-2.321-5.276-5.276v-63.31c0-2.954,2.321-5.276,5.276-5.276h63.31C435.575,47.483,437.896,49.805,437.896,52.759z
M121.345,369.311c0,2.954-2.321,5.276-5.276,5.276H58.034v58.034c0,2.742-2.321,5.276-5.276,5.276
c-2.954,0-5.276-2.321-5.276-5.276v-63.31c0-2.954,2.321-5.276,5.276-5.276h63.31C119.023,364.035,121.345,366.356,121.345,369.311z
M437.896,369.311c0,2.954-2.321,5.276-5.276,5.276h-58.034v58.034c0,2.742-2.321,5.276-5.276,5.276
c-2.954,0-5.276-2.321-5.276-5.276v-63.31c0-2.954,2.321-5.276,5.276-5.276h63.31C435.575,364.035,437.896,366.356,437.896,369.311z
"
      />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </SvgIcon>,
  'Insights Central': <SvgIcon
    color="primary"
    style={SvgStyle}
    viewBox="0 0 512 512"
  >
    <g>
      <g>
        <path d="M504.485,496.971H455.89v-297.08c0-4.15-3.364-7.515-7.515-7.515h-80.156c-4.151,0-7.515,3.365-7.515,7.515v297.08
  h-57.111V288.063c0-4.15-3.364-7.515-7.515-7.515h-80.156c-4.151,0-7.515,3.365-7.515,7.515v208.908h-57.111V328.141
  c0-4.15-3.364-7.515-7.515-7.515H63.625c-4.151,0-7.515,3.365-7.515,7.515v168.829H7.515c-4.151,0-7.515,3.365-7.515,7.515
  C0,508.635,3.364,512,7.515,512h496.97c4.151,0,7.515-3.365,7.515-7.515C511.999,500.335,508.636,496.971,504.485,496.971z
   M136.266,496.971H71.139V335.656h65.127V496.971z M288.564,496.971h-65.127V295.578h65.127V496.971z M440.861,496.971h-65.127
  V207.406h65.127V496.971z"
        />
      </g>
    </g>
    <g>
      <g>
        <path d="M488.008,5.895c-5.065-4.471-11.806-6.554-18.506-5.712l-64.125,8.016c-12.73,1.591-22.036,13.54-20.443,26.283
  c1.609,12.877,13.39,22.054,26.284,20.444l5.232-0.653c-78.705,91.256-172.272,138.418-238.39,162.12
  c-82.441,29.555-146.608,32.083-147.233,32.104c-12.963,0.405-23.191,11.282-22.799,24.247
  c0.388,12.804,10.721,22.833,23.526,22.833c0.238,0,0.477-0.003,0.722-0.011c2.853-0.086,70.874-2.488,160.489-34.42
  c50.378-17.952,97.782-41.783,140.893-70.83c3.442-2.318,4.352-6.99,2.032-10.431c-2.318-3.443-6.988-4.352-10.431-2.033
  c-42.068,28.346-88.343,51.607-137.539,69.137c-87.413,31.147-153.145,33.471-155.894,33.554l-0.272,0.004
  c-4.628,0-8.364-3.627-8.504-8.258c-0.142-4.69,3.558-8.624,8.25-8.771c0.656-0.021,66.654-2.443,151.832-32.978
  c71.359-25.581,173.893-77.814,257.126-181.378c4.144-5.156-0.237-12.985-6.788-12.164l-24.112,3.014
  c-4.18,0.517-8.24-2.222-9.301-6.304c-1.276-4.912,2.156-9.968,7.186-10.598l64.127-8.016c5.007-0.633,9.571,3.414,9.571,8.451
  v64.125c0,4.696-3.82,8.517-8.517,8.517s-8.517-3.82-8.517-8.517V68.23c0-3.071-1.986-5.943-4.858-7.028
  c-2.967-1.121-6.473-0.18-8.479,2.276c-28.067,34.391-60.025,65.511-94.988,92.495c-3.285,2.536-3.894,7.255-1.358,10.541
  c2.536,3.286,7.257,3.893,10.541,1.358c30.455-23.505,58.685-50.066,84.137-79.141c0.556,12.493,10.894,22.487,23.523,22.487
  c12.983,0,23.546-10.563,23.546-23.546V23.547C495.97,16.797,493.068,10.362,488.008,5.895z"
        />
      </g>
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </SvgIcon>,
  'BixConnect Page': <SvgIcon
    color="primary"
    style={SvgStyle}
    viewBox="0 -24 414 414"
  >
    <path d="m367 365.304688h-320c-25.914062 0-47-21.085938-47-47v-271.304688c0-25.914062 21.085938-47 47-47h320c25.914062 0 47 21.085938 47 47v271.304688c0 25.914062-21.085938 47-47 47zm-320-351.304688c-18.195312 0-33 14.804688-33 33v271.304688c0 18.195312 14.804688 33 33 33h320c18.195312 0 33-14.804688 33-33v-271.304688c0-18.195312-14.804688-33-33-33zm0 0" />
    <path d="m350.820312 258.433594h-109.996093c-3.867188 0-7-3.132813-7-7 0-3.863282 3.132812-7 7-7h109.996093c3.863282 0 7 3.136718 7 7 0 3.867187-3.132812 7-7 7zm0 0" />
    <path d="m350.820312 309.042969h-109.996093c-3.867188 0-7-3.132813-7-7 0-3.863281 3.132812-7 7-7h109.996093c3.863282 0 7 3.136719 7 7 0 3.867187-3.132812 7-7 7zm0 0" />
    <path d="m350.820312 157.214844h-109.996093c-3.867188 0-7-3.132813-7-7 0-3.863282 3.132812-7 7-7h109.996093c3.863282 0 7 3.136718 7 7 0 3.867187-3.132812 7-7 7zm0 0" />
    <path d="m350.820312 207.824219h-109.996093c-3.867188 0-7-3.132813-7-7 0-3.863281 3.132812-7 7-7h109.996093c3.863282 0 7 3.136719 7 7 0 3.867187-3.132812 7-7 7zm0 0" />
    <path d="m407 93.730469h-400c-3.867188 0-7-3.132813-7-7 0-3.867188 3.132812-7 7-7h400c3.867188 0 7 3.132812 7 7 0 3.867187-3.132812 7-7 7zm0 0" />
    <path d="m100.914062 68.78125c-12.011718 0-21.785156-9.769531-21.785156-21.78125s9.773438-21.78125 21.785156-21.78125c12.011719 0 21.78125 9.769531 21.78125 21.78125s-9.769531 21.78125-21.78125 21.78125zm0-29.5625c-4.292968 0-7.785156 3.492188-7.785156 7.78125s3.492188 7.78125 7.785156 7.78125c4.289063 0 7.78125-3.492188 7.78125-7.78125s-3.492187-7.78125-7.78125-7.78125zm0 0" />
    <path d="m50.476562 68.78125c-12.007812 0-21.78125-9.769531-21.78125-21.78125s9.773438-21.78125 21.78125-21.78125c12.011719 0 21.785157 9.769531 21.785157 21.78125s-9.773438 21.78125-21.785157 21.78125zm0-29.5625c-4.289062 0-7.78125 3.492188-7.78125 7.78125s3.492188 7.78125 7.78125 7.78125c4.292969 0 7.785157-3.492188 7.785157-7.78125s-3.492188-7.78125-7.785157-7.78125zm0 0" />
    <path d="m151.347656 68.78125c-12.011718 0-21.78125-9.769531-21.78125-21.78125s9.769532-21.78125 21.78125-21.78125c12.011719 0 21.785156 9.769531 21.785156 21.78125s-9.773437 21.78125-21.785156 21.78125zm0-29.5625c-4.292968 0-7.78125 3.492188-7.78125 7.78125s3.492188 7.78125 7.78125 7.78125c4.292969 0 7.785156-3.492188 7.785156-7.78125s-3.492187-7.78125-7.785156-7.78125zm0 0" />
    <path d="m188 309.042969h-127c-3.867188 0-7-3.132813-7-7v-151.828125c0-3.863282 3.132812-7 7-7h127c3.867188 0 7 3.136718 7 7v151.828125c0 3.867187-3.132812 7-7 7zm-120-14h113v-137.828125h-113zm0 0" />
  </SvgIcon>,
  Settings: <SvgIcon
    color="primary"
    style={SvgStyle}
    viewBox="0 0 456.556 456.556"
  >
    <g>
      <path d="M97.564,79.443H13.428C6.011,79.443,0,73.428,0,66.015s6.011-13.428,13.428-13.428h84.136
c7.417,0,13.428,6.015,13.428,13.428S104.981,79.443,97.564,79.443z"
      />
      <path d="M145.643,127.518c-33.916,0-61.507-27.591-61.507-61.504c0-33.92,27.591-61.511,61.507-61.511s61.507,27.591,61.507,61.511
C207.15,99.928,179.559,127.518,145.643,127.518z M145.643,31.36c-19.107,0-34.651,15.547-34.651,34.654
s15.544,34.647,34.651,34.647s34.651-15.54,34.651-34.647S164.75,31.36,145.643,31.36z"
      />
      <path d="M443.128,79.443H242.433c-7.417,0-13.428-6.015-13.428-13.428s6.011-13.428,13.428-13.428h200.694
c7.417,0,13.428,6.015,13.428,13.428S450.545,79.443,443.128,79.443z"
      />
      <path d="M325.936,289.782c-33.917,0-61.507-27.591-61.507-61.504s27.591-61.504,61.507-61.504s61.507,27.591,61.507,61.504
S359.853,289.782,325.936,289.782z M325.936,193.631c-19.107,0-34.651,15.54-34.651,34.647s15.544,34.647,34.651,34.647
s34.651-15.54,34.651-34.647S345.043,193.631,325.936,193.631z"
      />
      <path d="M229.149,241.706H13.428C6.011,241.706,0,235.691,0,228.278s6.011-13.428,13.428-13.428h215.721
c7.417,0,13.428,6.015,13.428,13.428S236.566,241.706,229.149,241.706z"
      />
      <path d="M443.128,241.706h-69.113c-7.417,0-13.428-6.015-13.428-13.428s6.011-13.428,13.428-13.428h69.113
c7.417,0,13.428,6.015,13.428,13.428S450.545,241.706,443.128,241.706z"
      />
      <path d="M130.62,452.052c-33.916,0-61.507-27.591-61.507-61.511c0-33.913,27.591-61.504,61.507-61.504s61.507,27.591,61.507,61.504
C192.127,424.461,164.536,452.052,130.62,452.052z M130.62,355.894c-19.107,0-34.651,15.54-34.651,34.647
s15.544,34.654,34.651,34.654s34.651-15.547,34.651-34.654S149.727,355.894,130.62,355.894z"
      />
      <path d="M443.128,403.97H227.407c-7.417,0-13.428-6.015-13.428-13.428c0-7.413,6.011-13.428,13.428-13.428h215.721
c7.417,0,13.428,6.015,13.428,13.428C456.556,397.955,450.545,403.97,443.128,403.97z"
      />
      <path d="M82.541,403.97H13.428C6.011,403.97,0,397.955,0,390.541c0-7.413,6.011-13.428,13.428-13.428h69.113
c7.417,0,13.428,6.015,13.428,13.428C95.969,397.955,89.958,403.97,82.541,403.97z"
      />
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </SvgIcon>,
  'Get Started': <SvgIcon
    color="primary"
    style={SvgStyle}
    viewBox="0 0 337.173 337.173"
  >
    <g>
      <g>
        <path d="M25.922,337.173V0l285.329,168.595L25.922,337.173z M42.179,28.491v280.2L279.29,168.595
L42.179,28"
        />
      </g>
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </SvgIcon>,
};

export const DealStatus = {
  1: 'Created',
  2: 'Archived',
  3: 'Won',
  4: 'Lost',
  5: 'Deleted',
};

export const DealStatusId = {
  Created: 1,
  Archived: 2,
  Won: 3,
  Lost: 4,
  Deleted: 5,
};

export const dealStageCount = {
  three: '3',
  six: '6',
  nine: '9',
};

export const Component = {
  1: 'Textbox',
  2: 'Multiline',
  3: 'Single checkbox',
  4: 'Multiple checkbox',
  5: 'Dropdown',
  6: 'Radio',
  7: 'Date picker',
  8: 'Number',
  9: 'Phone number',
  10: 'Rating',
  11: 'Paragraph',
  12: 'Divider',
  13: 'Label',
  14: 'Image',
  15: 'Section',
  16: 'availablehours',
  17: 'Docs'
};

export const Country = {
  USA: 1,
  Cameroon: 40,
};

export const CurrencySymbol = {
  USD: '$',
  INR: '₹',
  AED: 'Ø¯.Ø¥',
  AFN: 'Ø‹',
  ALL: 'L',
  AMD: 'Õ¤Ö€.',
  ANG: 'ƒ',
  AOA: 'Kz',
  ARS: '$',
  AUD: '$',
  AWG: 'ƒ',
  AZN: 'm',
  BAM: 'ÐšÐœ',
  BBD: '$',
  BDT: 'à§³',
  BGN: 'Ð»Ð²',
  BHD: '.Ø¯.Ø¨',
  BIF: 'Fr',
  BMD: '$',
  BND: '$',
  BOB: 'Bs.',
  BOV: '',
  BRL: 'R$',
  BSD: '$',
  BTN: 'Nu.',
  BWP: 'P',
  BYN: 'Br',
  BZD: '$',
  CAD: '$',
  CDF: 'Fr',
  CHE: '',
  CHF: 'Fr',
  CHW: '',
  CLF: '',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  COU: '',
  CRC: 'â‚¡',
  CUC: '$',
  CUP: '$',
  CVE: 'Esc or $',
  CZK: 'KÄ',
  DJF: 'Fr',
  DKK: 'kr',
  DOP: '$',
  DZD: 'Ø¯.Ø¬',
  EGP: 'Ø¬.Ù…',
  ERN: 'Nfk',
  ETB: 'Br',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GBP: '£',
  GEL: 'áƒš',
  GHS: 'â‚µ',
  GIP: '£',
  GMD: 'D',
  GNF: 'Fr',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  IMP: '£',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'kr',
  JEP: '£',
  JMD: '$',
  JOD: 'د.ا',
  JPY: '¥',
  KES: 'Sh',
  KGS: 'лв',
  KHR: '៛',
  KMF: 'Fr',
  KPW: '₩',
  KRW: '₩',
  KWD: 'د.ك',
  KYD: '$',
  KZT: '₸',
  LAK: '₭',
  LBP: 'ل.ل',
  LKR: 'Rs',
  LRD: '$',
  LSL: 'L',
  LYD: 'ل.د',
  MAD: 'د.م.',
  MDL: 'L',
  MGA: 'Ar',
  MKD: 'ден',
  MMK: 'Ks',
  MNT: '₮',
  MOP: 'P',
  MRU: 'UM',
  MUR: '₨',
  MVR: '.ރ',
  MWK: 'MK',
  MXN: '$',
  MYR: 'RM',
  MZN: 'MT',
  NAD: '$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: 'ر.ع.',
  PAB: 'B/.',
  PEN: 'S/.',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: '₲',
  QAR: 'ر.ق',
  RON: 'lei',
  RSD: 'дин.',
  RUB: '₽',
  RWF: 'Fr',
  SAR: 'ر.س',
  SBD: '$',
  SCR: '₨',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: '$',
  SHP: '£',
  SLL: 'Le',
  SOS: 'Sh',
  SRD: '$',
  SSP: '£',
  STN: 'Db',
  SVC: '₡',
  SYP: '£',
  SZL: 'L',
  THB: '฿',
  TJS: 'ЅМ',
  TMT: 'm',
  TND: 'د.ت',
  TOP: 'T$',
  TRY: '₺',
  TTD: '$',
  TVD: '$',
  TWD: 'NT$',
  TZS: 'Sh',
  UAH: '₴',
  UGX: 'Sh',
  UYU: '$U',
  UZS: 'лв',
  VEF: 'Bs',
  VND: '₫',
  VUV: 'Vt',
  WST: 'T',
  XAF: 'Fr',
  XCD: '$',
  XDR: 'SDR',
  XOF: 'Fr',
  XPF: '₣',
  YER: '﷼',
  ZAR: 'R',
  ZMW: 'ZK',
  ZWL: '$',
};

export const State = {
  Alabama: 1,
};

export const EventStatus = {
  Active: 'active',
  Cancel: 'cancel',
};

export const InitialProperty = [
  {
    fieldtype: 13,
    name: 'Label',
    objecttype: 'Designing',
    propertyid: '19384760-3380-4e09-a657-9306887098a2',
    propertyname: 'Label',
    value: 'Enter Details',
  },
  {
    fieldtype: 1,
    isrequired: true,
    name: 'First Name',
    objecttype: 'contact',
    options: null,
    propertyid: '6220cc1b-db4b-41ba-b06a-98e205a8b0de',
    propertyname: 'First Name',
  },
  {
    fieldtype: 1,
    isrequired: false,
    name: 'Last Name',
    objecttype: 'contact',
    options: null,
    propertyid: 'd49c4f77-969d-4c71-a247-f619f8936fa3',
    propertyname: 'Last Name',
  },
  {
    fieldtype: 1,
    isrequired: true,
    name: 'Email',
    objecttype: 'contact',
    options: null,
    propertyid: '98008ddc-860b-4e1c-8773-8c405e21f2f1',
    propertyname: 'Email',
  },
  {
    fieldtype: 1,
    isrequired: false,
    name: 'Job Title',
    objecttype: 'contact',
    options: null,
    propertyid: '21fe003a-2518-42d7-9f4c-06888c850fc5',
    propertyname: 'Job Title',
  },
  {
    fieldtype: 9,
    isrequired: false,
    name: 'Phone Number',
    objecttype: 'contact',
    options: null,
    propertyid: 'dd7e8234-dbc7-49bd-9a4d-fbce3be1432b',
    propertyname: 'Phone Number',
  },
  {
    fieldtype: 1,
    isrequired: true,
    name: 'Organization Name',
    objecttype: 'organization',
    options: null,
    propertyid: 'c3132ff5-ad93-4e0d-ab67-4b15202635c9',
    propertyname: 'Organization Name',
  },
  {
    fieldtype: 1,
    isrequired: false,
    name: 'Website',
    objecttype: 'organization',
    options: null,
    propertyid: '11708729-2316-4212-b9b2-7c1786a6a798',
    propertyname: 'Website',
  },
  {
    fieldtype: 1,
    isrequired: false,
    name: 'Linkedin',
    objecttype: 'contact',
    options: null,
    propertyid: '72402289-3a8e-4203-84ef-bb2ab6caf5e9',
    propertyname: 'Linkedin',
  },
];
